/**
 * @description: 商品管理
 * @author: hwx
 * @update: lyr
 */
<template>
<div class="page_content">
    <ul class="row list-tit" v-show="titShow">
        <!-- <li class="col-md-3"><span class="col-md-10" @click="titClk('1')">商品列表</span></li>
        <li class="col-md-3"><span class="col-md-10" @click="titClk('2')">商品类型</span></li>
        <li class="col-md-3"><span class="col-md-10" @click="titClk('3')">商品口味</span></li> -->
        <li class="col-md-3" v-for="menuItem in menu" :key="menuItem.id"><span class="col-md-10" @click="titClk(menuItem.name)">{{menuItem.name}}</span></li>
    </ul>
    <div class="list-con">
        <div class="commodity-list" v-show="listShow1">
            <!--列表-->
            <div class="list_content" v-show="listPage">
                <div class="row rowmagin" v-if="list_menu_add">
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="addCommodity">新增商品</button>
                    <a href="https://vodonline.oss-cn-beijing.aliyuncs.com/Download/goodsImportTemplate_v3.xls" class="btn bg-orange btn-flat bigbtn">新增商品模板下载</a>
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="addXlsFun">直接导入商品模板</button>
                    <input type="file" @change="uploadCmdyXls($event)" ref="cmdyXlsFile" id="cmdyXlsFile">
                    <button type="button" class="btn bg-orange btn-flat bigbtn sub-margin" @click="cmdyMutilDel" v-show="list_menu_del">商品批量删除</button>
                </div>
                <div class="row row-margin">
                    <label class="ct-label">门店:</label>
                    <div class="col-md-2 ct-col">
                        <select class="form-control" ref="shopbtn" data-placeholder="请选择门店"></select>
                    </div>
                    <label class="col-md-1 control-label" style="width: 32px;">类型:</label>
                    <div class="col-md-2">
                        <select class="form-control select2" style="width: 100%;" ref="commodity_type" data-placeholder="请选择类型"></select>
                    </div>
                    <label class="col-md-1 control-label" style="width: 60px;">推荐商品:</label>
                    <div class="col-md-2">
                        <select class="form-control select2" style="width: 100%;" ref="recommend_goods" data-placeholder="请选择是否推荐商品">
                            <option></option>
                            <option value="1">是</option>
                            <option value="-1">否</option>
                        </select>
                    </div>
                    <label class="col-md-1 control-label formname" style="width: 60px; padding: 0;">销售商品:</label>
                    <div class="col-md-2">
                        <select class="form-control selectStock" ref="actual_sale" data-placeholder="是否销售商品">
                            <option value="">全部</option>
                            <option value="1">是</option>
                            <option value="-1">否</option>
                        </select>
                    </div>
                    <label class="col-md-1 control-label" style="width: 32px;">状态:</label>
                    <div class="col-md-2" style="width: 120px;">
                        <select class="form-control select2" style="width: 100%;" ref="recommend_status">
                            <option value="1">启用</option>
                            <option value="-1">禁用</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <label class="col-md-1 control-label" style="width: 60px;">估清状态:</label>
                    <div class="col-md-2" style="width: 150px;">
                        <select class="form-control select2" style="width: 100%;" ref="gq_status" data-placeholder="请选择估清状态">
                            <option value="0">全部</option>
                            <option value="1">估清</option>
                            <option value="-1">未估清</option>
                        </select>
                    </div>
                    <label class="col-md-1 control-label" style="width: 60px;">商品名称:</label>
                    <div class="col-md-2">
                        <input class="form-control" id="name" placeholder="输入商品名称" v-model="goods_name">
                    </div>
                    <label class="col-md-1 control-label" style="width: 60px;">配料商品:</label>
                    <div class="col-md-2" style="width: 150px;">
                        <select class="form-control select2" style="width: 100%;" ref="gq_ingredient" data-placeholder="请选择是否配料商品">
                            <option value="0">不限</option>
                            <option value="1">是</option>
                            <option value="-1">否</option>
                        </select>
                    </div>
                    <div class="pull-right">
                        <button type="button" class="btn bg-orange btn-flat btn-middle" @click="multiServRate">商品批量修改</button>
                        <button type="button" class="btn bg-orange btn-flat btn-middle" @click="zeroSearch">查看0元商品</button>
                        <button type="button" class="btn bg-orange btn-flat btn-small" @click="getExportSet">导出</button>
                        <button type="button" class="btn bg-orange btn-flat btn-small" @click="maintablesearch">查询</button>
                    </div>
                </div>
                <div class="table-responsive">
                    <table ref="commodity_manage_table" class="table table-bordered table-hover" data-pagination="true"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backTit">返回</button>
                </div>
                <!-- 商品批量修改 -->
                <div class="goods-multi-edit" ref="goods_multi_edit">
                    <div class="row">
                        <label class="el-form-item__label">门店</label>
                        <div class="ct-col">
                            <select class="form-control" data-placeholder="请选择门店" ref="gme_shop"></select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="el-form-item__label">商品类型</label>
                        <div class="ct-col">
                            <input class="form-control input-readonly" placeholder="请选择商品类型" v-model="gme_txt" ref="gme_txt" @click="openGoodtype($event)" readonly>
                            <span class="selection-clear" @click="clearInput">×</span>
                            <span class="span-arrow" role="presentation"><b></b></span>
                        </div>
                    </div>
                    <div class="row">
                        <p class="p-hint">请勾选要编辑的项目</p>
                        <div class="row" v-for="(item, index) in gme_config" :key="index">
                            <el-checkbox v-model="item.check"></el-checkbox>
                            <label v-if="item.key==='vip_present_pay' || item.key==='vip_points_pay' || item.key==='included_give_ratio'" class="el-form-item__label beyond">{{item.label}}</label>
                            <label v-else class="el-form-item__label">{{item.label}}</label>
                            <el-select v-if="item.type==='select'&&item.key!='sales_commission'&&item.key!=='vip_present_pay'" v-model="item.value" :disabled="!item.check" popper-class="high-index">
                                <el-option label="是" value="1"></el-option>
                                <el-option label="否" value="-1"></el-option>
                            </el-select>
                            <el-select v-else-if="item.type==='select'&&item.key=='sales_commission'" v-model="item.value" :disabled="!item.check" popper-class="high-index">
                                <el-option label="计提成计业绩" value="1"></el-option>
                                <el-option label="无提成计业绩" value="2"></el-option>
                                <el-option label="无提成无业绩" value="3"></el-option>
                            </el-select>
                            <el-select v-else-if="item.type === 'select' && item.key == 'vip_present_pay'"
								v-model="item.value" :disabled="!item.check" popper-class="high-index">
								<el-option label="仅通用账户可支付" value="-1"></el-option>
								<el-option label="通用账户与赠送账户均可支付" value="1"></el-option>
								<el-option label="仅赠送账户可支付" value="2"></el-option>
								<el-option label="通用账户与赠送账户均不可支付" value="3"></el-option>
							</el-select>
                            <el-input v-else :placeholder="item.placeholder" v-model="item.value" :disabled="!item.check">
                                <template slot="append">{{item.unit}}</template>
                            </el-input>
                        </div>
                    </div>
                </div>
                <!-- 商品类型 -->
                <div class="ele-hide" ref="gme_alert">
                    <div class="multi-select">
                        <div class="clearfix">
                            <input type='checkbox' v-model='gme_all' @click='servRateCheckAll'>
                            <span>全选</span>
                        </div>
                        <ul class="clearfix">
                            <li v-for="item in gme_arr" :key="item.id">
                                <input type="checkbox" v-model='gme_item' :value="item.id">
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 导出设置弹窗 -->
                <div class="ele-hide" ref="export_alert">
                    <div class="set-export sel-seldiv">
                        <h3>请选择导出报表需要的显示的字段</h3>
                        <ul class="set-area clearfix">
                            <li>
                                <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                                <label>全选</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="listorder">
                                <label>显示顺序</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="shop_name">
                                <label>门店</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="barcodes">
                                <label>商品条形码</label>
                            </li>
                            <!-- <li>
                                <input type="checkbox" v-model='export_checkModel' value="good_img">
                                <label>商品图片</label>
                            </li> -->
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="goods_name">
                                <label>商品别名</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
                                <label>商品单位</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="goods_type_name">
                                <label>商品类型</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="cost_price">
                                <label>原价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="discount_price">
                                <label>优惠价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="recommend">
                                <label>推荐商品</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="is_sell">
                                <label>销售商品</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="status">
                                <label>状态</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="guqing">
                                <label>估清状态</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_price">
                                <label>会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level1_price">
                                <label>一级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level2_price">
                                <label>二级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level3_price">
                                <label>三级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level4_price">
                                <label>四级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level5_price">
                                <label>五级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level6_price">
                                <label>六级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level7_price">
                                <label>七级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level8_price">
                                <label>八级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level9_price">
                                <label>九级会员价</label>
                            </li>
                            <li>
                                <input type="checkbox" v-model='export_checkModel' value="vip_level10_price">
                                <label>十级会员价</label>
                            </li>
                        </ul>
                        <h3>请选择导出报表的文件格式</h3>
                        <ul class="clearfix">
                            <li>
                                <input type="radio" v-model='export_type' value="1">
                                <label>excel表格</label>
                            </li>
                            <li>
                                <input type="radio" v-model='export_type' value="2">
                                <label>pdf文件</label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 商品批量删除 -->
			<div class="alert-wrap" ref="cmdy_multi_del">
                <p class="p-hint">注：确定删除后，选中的商品类型下的所有商品将被删除，且不可恢复</p>
				<el-form :model="multi_del_form" label-width="120px">
                    <el-form-item label="门店">
                        <el-select v-model="multi_del_form.shop_id" filterable placeholder="请选择门店">
                            <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品类型">
                        <el-select v-model="multi_del_form.goods_type" filterable placeholder="请选择商品类型">
                            <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
			</div>

            <!-- 新增/修改商品 -->
            <div class="list-det" v-show="detPage">
                <div class="page-tit">{{page_header}}</div>
                <!-- <p class="page-flow"><span>新增商品流程：</span>输入商品条码 <span>></span> 点下一步 <span>></span> 填写商品资料 <span>></span> 完成</p> -->
                <div class="add-code clearfix">
                    <h4>条码资料</h4>
                    <div class="row rowpadding">
                        <div class="col-md-6">
                            <label class="col-md-2 control-label">条形码1:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="输入商品条形码或用扫描枪扫条形码" v-model="modify_bar_code1" ref="modify_bar_code1" @blur="onBarcodeBlur">
                            </div>
                            <img src="../../assets/images/icon_add.png" @click="addBarCode">
                        </div>
                        <div class="col-md-6 bar-code-2 bar-code-hide">
                            <label class="col-md-2 control-label">条形码2:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="输入商品条形码或用扫描枪扫条形码" v-model="modify_bar_code2" ref="modify_bar_code2">
                            </div>
                            <img src="../../assets/images/icon_del.png" @click="delBarCode($event, 2)">
                        </div>
                        <div class="col-md-6 bar-code-3 bar-code-hide">
                            <label class="col-md-2 control-label">条形码3:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="输入商品条形码或用扫描枪扫条形码" v-model="modify_bar_code3" ref="modify_bar_code3">
                            </div>
                            <img src="../../assets/images/icon_del.png" @click="delBarCode($event, 3)">
                        </div>
                        <div class="col-md-6 bar-code-4 bar-code-hide">
                            <label class="col-md-2 control-label">条形码4:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="输入商品条形码或用扫描枪扫条形码" v-model="modify_bar_code4" ref="modify_bar_code4">
                            </div>
                            <img src="../../assets/images/icon_del.png" @click="delBarCode($event, 4)">
                        </div>
                        <div class="col-md-6 bar-code-5 bar-code-hide">
                            <label class="col-md-2 control-label">条形码5:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="输入商品条形码或用扫描枪扫条形码" v-model="modify_bar_code5" ref="modify_bar_code5">
                            </div>
                            <img src="../../assets/images/icon_del.png" @click="delBarCode($event, 5)">
                        </div>
                        <div class="col-md-6 bar-code-6 bar-code-hide">
                            <label class="col-md-2 control-label">条形码6:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="输入商品条形码或用扫描枪扫条形码" v-model="modify_bar_code6" ref="modify_bar_code6">
                            </div>
                            <img src="../../assets/images/icon_del.png" @click="delBarCode($event, 6)">
                        </div>
                        <div class="col-md-6 bar-code-7 bar-code-hide">
                            <label class="col-md-2 control-label">条形码7:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="输入商品条形码或用扫描枪扫条形码" v-model="modify_bar_code7" ref="modify_bar_code7">
                            </div>
                            <img src="../../assets/images/icon_del.png" @click="delBarCode($event, 7)">
                        </div>
                    </div>
                </div>
                <div class="list-base clearfix">
                    <h4>基本资料</h4>
                    <div class="col-md-6">
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">门店:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" ref="add_shop" data-placeholder="请选择门店"></select>
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">商品名称:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入商品名称" v-model="cmdy_name" ref="cmdy_name">
                            </div>
                            <span class="rmarkspan" titles="在显示端不显示，在跨门店调拨时显示" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                            <img src="../../assets/images/icon_add.png" style="width: 30px; margin-left: 10px; cursor: pointer;" @click="onAddIconClick">
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">商品别名:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入商品别名" v-model="cmdy_nickname">
                            </div>
                            <span class="rmarkspan" titles="在显示端显示的商品名称" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">商品单位:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" ref="commodity_unit" data-placeholder="请选择商品单位"></select>
                            </div>
                            <img src="../../assets/images/icon_add.png" style="width: 29px; cursor: pointer;" @click="addCmdyUnit">
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">商品类型:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_detailtype" data-placeholder="请选择商品类型"></select>
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">原价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写原价，原价用于商品被划线价格" v-model="cmdy_price">
                            </div>
                            <span class="rmarkspan" titles="原价是用仅起到显示作用，终端删除线显示：<br />如：<del>原价200元</del> &nbsp;&nbsp;&nbsp; 优惠价150元" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">优惠价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写优惠价格，优惠价格是非会员享受的价格" v-model="cmdy_disctprice">
                            </div>
                            <span class="rmarkspan" titles="优惠价是非会员消费者购买商品后的最后支付价。终端删除线显示<br />如：<del>原价200元</del> &nbsp;&nbsp;&nbsp; 优惠价150" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写会员价，会员价是使用会员卡后享受的价格" v-model="cmdy_viprice">
                            </div>
                            <span class="rmarkspan" titles="注册成为会员后享受的价格。场所如果有设置会员打折和会员价的话会同时起作用。" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                            <span class="cmdy-vip-hint">会员价设置为0时等于优惠价</span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">显示顺序:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入商品终端显示顺序，例如：01.02.03" v-model="cmdy_sequence">
                            </div>
                            <span class="rmarkspan" titles="显示顺序，数字大的显示在前" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h5>—— 不同会员等级会员价设置 ——</h5>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">一级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写一级会员等级享受的会员价" v-model="vip_level1_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">二级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写二级会员等级享受的会员价" v-model="vip_level2_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">三级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写三级会员等级享受的会员价" v-model="vip_level3_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">四级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写四级会员等级享受的会员价" v-model="vip_level4_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">五级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写五级会员等级享受的会员价" v-model="vip_level5_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">六级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写六级会员等级享受的会员价" v-model="vip_level6_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">七级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写七级会员等级享受的会员价" v-model="vip_level7_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">八级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写八级会员等级享受的会员价" v-model="vip_level8_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">九级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写九级会员等级享受的会员价" v-model="vip_level9_price">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-2 control-label">十级会员价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="填写十级会员等级享受的会员价" v-model="vip_level10_price">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-other clearfix">
                    <h4>其他资料</h4>
                    <div class="col-md-6">
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">赠送商品:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_giving" data-placeholder="是否赠送商品">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">商品是否允许打折:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_discount" data-placeholder="是否商品打折">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">销售商品:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_sale" data-placeholder="是否销售商品">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="销售商品【是】在触屏，微信端，支付宝端，app点单收银可售卖商品。【否】在触摸屏，微信端，支付宝端，app点单收银等售卖入口不显示。非销售商品可以设置套餐和赠送，配送的商品。" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">推荐商品:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_recommended" data-placeholder="是否推荐商品">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="推荐商品是在微信或支付宝巨嗨首页推荐商品" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">是否属低消:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_min" data-placeholder="是否属低消">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="【是】：当前商品的优惠价要抵扣计时开房低消金额<br />【否】：当前商品的优惠价不抵扣计时开房低消金额" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">是否盘点:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_pd">
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label" style="line-height: normal">会员账户可支付设置:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_hz">
                                    <option value="-1">仅通用账户可支付</option>
                                    <option value="1">通用账户与赠送账户均可支付</option>
                                    <option value="2">仅赠送账户可支付</option>
                                    <option value="3">通用账户与赠送账户均不可支付</option>
                                </select>
                            </div>
                        </div>
                        <div class="row rowpadding" v-show="vip_shareholder_status">
                            <label class="col-md-3 control-label">预估成本价:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入预估成本价" v-model="commodity_forecast_cost">
                            </div>
                            <span class="rmarkspan" titles="用以计算商品利润的一个数值<br />商品利润=（商品折后价-预估成本价）*毛利" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label" style="line-height: normal">是否计入可赠送比例:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_kzb" data-placeholder="是否计入可赠送比例">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="该商品是否计入账单消费金额，用于计算赠送金额比例【是】计入账单消费金额，可用于赠送金额比例【否】不计入账单消费金额，即不可用于赠送金额比例" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">业绩提成属性:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_sales_commission">
                                    <option value="1">计提成计业绩</option>
                                    <option value="2">无提成计业绩</option>
                                    <option value="3">无提成无业绩</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">消费者端显示:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_cshow" data-placeholder="消费者端是否显示">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="【是】：在触摸屏，智慧商家app，微信端，支付宝端均显示。<br />【否】：只在智慧商家app端显示。" @mouseenter="hint_language($event, 4)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">算订台业绩:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_dt" data-placeholder="是否算订台业绩">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="【是】：商品销售后需要算入订台业绩明细报表和订台业绩汇总报表。<br />【否】：商品销售后不算入订台业绩明细报表和订台业绩汇总报表。" @mouseenter="hint_language($event, 4)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">提成金额:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入商品提成金额" v-model="commodity_tc_numb" ref="commodity_tc_numb">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">提成百分比:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入商品提成百分比" v-model="commodity_tc_perc" ref="commodity_tc_perc">
                            </div>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">服务费收取比例:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入数字，如1，2，3..." v-model="commodity_serv_perc">
                            </div>
                            <span class="ctr-hint-txt">%</span>
                            <span class="rmarkspan" titles="设置为0则不收服务费，设置0以上的数字则在结账时包厢账单按该商品设置的比例收取服务费。" @mouseenter="hint_language($event, 4)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">优惠券是否可用:</label>
                            <div class="col-md-8 ct-col">
                                <select class="form-control" ref="commodity_disc_use">
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="【是】该商品在支付时可算入优惠券可用金额。<br/>【否】该商品在支付时金额不算入优惠券可用金额。" @mouseenter="hint_language($event, 4)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label" style="line-height: normal">是否适用会员积分抵扣金额:</label>
                            <div class="col-md-8">
                                <select class="form-control" ref="commodity_hjd">
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                        </div>
                        <div class="row rowpadding" v-show="vip_shareholder_status">
                            <label class="col-md-3 control-label">毛利百分比:</label>
                            <div class="col-md-8">
                                <input class="form-control" placeholder="请输入毛利百分比" v-model="commodity_gross_ratio">
                            </div>
                            <span class="ctr-hint-txt">%</span>
                            <span class="rmarkspan" titles="用以计算商品利润的一个数值<br />商品利润=（商品折后价-预估成本价）*毛利" @mouseenter="hint_language($event, 4)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">时价商品:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_sjsp" data-placeholder="下单时是否可修改商品价格">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="是：该商品下单时可修改商品价格" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                        <div class="row rowpadding">
                            <label class="col-md-3 control-label">是否配料商品:</label>
                            <div class="col-md-8">
                                <select class="form-control select2" style="width: 100%;" ref="commodity_ingredient" data-placeholder="请选择是否配料商品">
                                    <option></option>
                                    <option value="1">是</option>
                                    <option value="-1">否</option>
                                </select>
                            </div>
                            <span class="rmarkspan" titles="是：该商品可用于其他商品作为配料关联，并根据售卖商品设置的数量关联库存变化" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
                        </div>
                    </div>
                </div>
                <div class="list-img">
                    <div class="row clearfix">
                        <h4>
                            商品显示图片
                            <span>（图片是在微信端，支付宝端，app端，触摸屏端显示。【图片规范：500*500，大小不超过2m，格式为png】）</span>
                        </h4>
                        <div class="col-md-2">
                            <img class="defaultimage1" :src="submitimg1" @load="successLoadImg($event)" @error="errorLoadImg">
                            <input type="file" class="uploadinput" @change="uploadimgFun($event)" ref="isflies1" id="isflies1" />
                            <img src="../../assets/images/vod_del.png" alt="" class="del-icon" v-if="isOnlineImg"  @click.stop="onImgDel">
                        </div>
                        <div class="col-md-2">
                            <div class="btns">
                                <el-button type="primary" @click="chooseCloudImg">图库选择</el-button>
                                <el-button type="primary" @click="addimageFun">本地上传</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="row clearfix">
                        <h4>
                            商品简介
                            <span>（设置后，微信端自助点单点击商品详情时，可查看商品简介内容）</span>
                        </h4>
                        <div class="col-md-5">
                            <textarea placeholder="请输入商品简介" v-model="commodity_des"></textarea>
                        </div>
                    </div>
                </div>
                <div class="list-video">
                    <div class="row clearfix">
                        <h4>
                            商品视频展示
                            <span>（商品视频仅应用于平板app点单展示，可用视频形式展示商品）</span>
                        </h4>
                        <h5>视频内容<span class="red-txt">视频格式为mp4，大小不超过5M。视频分辨率建议比例为图片尺寸（500*500）一致，若分辨率不一致，可能存在不满屏播放情况</span></h5>
                    </div>
                    <div class="video-wrapper" id="video-wrapper">
                        <img src="../../assets/images/uld_btn.png" alt="" v-if="video_url==''">
                        <video :src="video_url" controls v-else></video>
                        <img src="../../assets/images/vod_del.png" alt="" class="del-icon" v-if="video_url!=''" @click.stop="onVideoDel">
                    </div>
                </div>
                <div class="list-syn">
                    <h4>资料同步<span>（以下门店如需同步更新当前商品资料请勾选）</span></h4>
                    <ul class="clearfix">
                        <li>
                            <input type='checkbox' v-model='syn_allcheck' @click='synCheckedAll'>
                            <label>全部</label>
                        </li>
                        <li v-for="item in syn_checkboxData" :key="item.id">
                            <input type="checkbox" v-model='syn_checkboxModel' :value='item.id'>
                            <label>{{item.text}}</label>
                        </li>
                    </ul>
                </div>
                <div class="list-taste">
                    <h4>商品口味 <el-button type="primary" size="mini" @click="addNewFlavorType">新增口味类型</el-button></h4>
                    <div class="flavor-row" v-for="(item,index) in good_detail.flavors_info">
                        <div class="row-label">口味类型</div>
                        <el-input class="short" placeholder="请输入口味类型名称" size="small" v-model="item.flavor_type"></el-input>
                        <div class="row-label">可选</div>
                        <el-input placeholder="请选择口味" size="small" readonly v-model="item.flavors_str" @click.native="openFlavorPickPop(index)"></el-input>
                        <el-button type="primary" size="small" @click="openFlavorPickPop(index)">挑选口味</el-button>
                        <el-button size="small" @click="delFlavorType(index)">删除</el-button>
                    </div>
                </div>
                <div class="list-coupon" v-if="business_model==2">
                    <h4>商品关联券</h4>
                    <div class="coupon-row">
                        <el-radio-group v-model="voucher_status">
                            <el-radio label="-1">关闭</el-radio>
                            <el-radio label="1">开启</el-radio>
                        </el-radio-group>
                        <el-input v-model="voucher_name" placeholder="请选择关联的券" readonly @click.native="openVoucherPop" :disabled="voucher_status==-1"></el-input>
                    </div>
                </div>
                <div class="list-ingredients">
                    <h4>
                        配料列表
                        <el-button type="primary" size="mini" @click="openAddIngredientsPop">添加商品</el-button>
                        <span class="red-tip">注：配料列表数据修改后，从修改之后售卖的数据才开始关联</span>
                    </h4>
                    <el-table
                        ref="ingredientsTable"
                        :data="ingredients_table"
                        :header-cell-style="{'text-align':'center'}"
                        :cell-style="{'text-align':'center'}">
                        <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                        <el-table-column prop="goods_name" label="商品名称"></el-table-column>
                        <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                        <el-table-column prop="quanity" label="数量">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.quantity" placeholder="请输入数量" @input="updateIngredientsQuantity(scope.row)" clearable></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="delIngredients(scope.$index)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="row" style="padding-top: 30px;">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" style="margin-right: 40px;" @click="backList">返回</button>
                    <!-- <button type="button" class="btn btn-flat btn-middle btn-orange" @click="listNext" ref="list_next">下一步</button> -->
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="goodSub(modify)" ref="list_sub">确定</button>
                </div>
            </div>
            <div class="list-qrcode" v-show="qrcodePage">
                <div class="page-tit">二维码</div>
                <ul>
                    <li>注：</li>
                    <li>1，商品二维码可以导出后贴在实物商品商品，消费者可通过微信扫码直接购买该商品</li>
                    <li>2，点击鼠标右键图片另存为即可导出</li>
                    <li>3，配送包厢：必填是消费者在下单时一定要填写包厢号，禁填是消费者在下单时不能填写包厢号，选填是消费者在下单时可填或者不填包厢号。</li>
                </ul>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">门店：</label>
                    <div class="col-md-6">
                        <span class="list-shop-cg col-md-12">{{list_shop_cg}}</span>
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">配送包厢必填：</label>
                    <div class="col-md-6">
                        <select class="form-control select2" ref="cmdy_qr_box">
                            <option value="3">禁填</option>
                            <option value="2">选填</option>
                            <option value="1">必填</option>
                        </select>
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-1 ctr-label-left">二维码：</label>
                    <div class="list-img-wrap col-md-6">
                        <img :src="list_qrcode">
                    </div>
                </div>
                <div class="row" style="padding-top: 30px;">
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" style="margin-right: 40px;" @click="backList">返回</button>
                </div>
            </div>
            <!-- 口味选择弹窗 -->
            <div class="flavor-pick-pop ele-hide" ref="flavor_pick_pop">
                <div class="pop-title">口味列表<el-button size="mini" @click="addCmdyTaste">+新增</el-button></div>
                <el-checkbox-group v-model="tlist_checkboxModel">
                    <el-checkbox :label="item.id" :key="item.id" v-for="item in tlist_checkboxData">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 关联券弹窗 -->
            <div class="coupon-pop ele-hide" ref="coupon_pop">
                <el-form :inline="true">
                    <el-select v-model="voucher_type" placeholder="请选择" @change="onVoucherTypeChange" popper-class="high-index">
                        <el-option label="卡券" value="1"></el-option>
                        <el-option label="售货机商品券" value="2"></el-option>
                    </el-select>
                    <el-select v-model="card_type_name" filterable clearable placeholder="卡券类型" v-if="voucher_type=='1'" @change="onPopQueryClick" popper-class="high-index">
                        <el-option :label="item.text" :value="item.id" :key="item.id" v-for="item in card_type"></el-option>
                    </el-select>
                    <el-select v-model="card_type_name" filterable clearable placeholder="商品券类型" v-if="voucher_type=='2'" @change="onPopQueryClick" popper-class="high-index">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="兑换券" value="1"></el-option>
                    </el-select>
                    <el-input v-model="query_voucher_name" clearable :placeholder="voucher_type=='1'?'请输入卡券名称':'请输入商品券名称'"></el-input>
                    <el-button type="primary" @click="onPopQueryClick">查询</el-button>   
                </el-form>
                <el-table
                    v-loading="pop_loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    ref="coupon_table"
                    :data="coupon_list"
                    @select="onPopCouponSelect">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="goods_type_name" label="类型"></el-table-column>
                    <el-table-column prop="goods_name" label="名称"></el-table-column>
                    <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="coupon_page_size"
                    :current-page.sync="coupon_page"
                    :total="coupon_total"
                    @current-change="getPopCouponList">
                </el-pagination>
            </div>
            <!-- 配料商品列表弹窗 -->
            <div class="ingredients-pop ele-hide" ref="add_ingredients_pop">
                <el-form :inline="true">
                    <el-select v-model="ingredients_pop_form.goods_type" placeholder="请选择商品类型" clearable popper-class="high-index">
                        <el-option v-for="item in goods_type_list" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                    <el-input v-model="ingredients_pop_form.goods_name" placeholder="请输入商品名称" clearable></el-input>
                    <el-button type="primary" @click="getIngredientsList(1)">查询</el-button>
                </el-form>
                <el-table
                    v-loading="pop_loading"
                    element-loading-text="努力加载中，请稍后..."
                    element-loading-background="rgba(0, 0, 0, 0.6)"
                    @selection-change="handleIngredientsPopSelectionChange"
                    :data="ingredients_pop_table">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="goods_type_name" label="类型"></el-table-column>
                    <el-table-column prop="goods_name" label="名称"></el-table-column>
                    <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="coupon_page_size"
                    :current-page.sync="ingredients_pop_page"
                    :total="ingredients_pop_total"
                    @current-change="getIngredientsList">
                </el-pagination>
            </div>
        </div>



        <div class="commodity-types" v-show="listShow2">
            <div class="types-list">
                <div class="row row-magin-bottom" v-if="types_menu_add">
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="typesSub(1)">添加类型</button>
                </div>
                <p>注：显示顺序大的在显示端显示靠前</p>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover bx-list" data-pagination="true" ref="typesList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backTit">返回</button>
                </div>
            </div>
            <!-- 添加、修改 -->
            <div class="types-edit" ref="types_edit">
                <div class="row rowpadding">
                    <label class="col-md-3 control-label">显示顺序:</label>
                    <div class="col-md-8">
                        <input class="form-control" placeholder="请输入显示顺序，例如01" v-model="types_sort">
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-3 control-label">商品类型:</label>
                    <div class="col-md-8">
                        <input class="form-control" placeholder="请输入商品类型" v-model="types_name">
                    </div>
                </div>
                <div class="row rowpadding">
                    <label class="col-md-3 control-label">消费者端显示:</label>
                    <div class="col-md-8">
                        <select class="form-control" ref="types_custm">
                            <option value="1">是</option>
                            <option value="-1">否</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>



        <div class="commodity-taste" v-show="listShow3">
            <div class="taste-list">
                <div class="row row-magin-bottom" v-if="taste_menu_add">
                    <button type="button" class="btn bg-orange btn-flat bigbtn" @click="tasteSub(1)" style="margin: 0 0 20px;">添加口味</button>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered table-hover bx-list" data-pagination="true" ref="tasteList"></table>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backTit">返回</button>
                </div>
            </div>
            <!-- 添加、修改 -->
            <div class="taste-edit" ref="taste_edit">
                <div class="row rowpadding">
                    <label class="col-md-3 control-label">商品口味:</label>
                    <div class="col-md-8">
                        <input class="form-control" placeholder="请输入商品口味" v-model="taste_name">
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- 商品列表 > 从商品库选择商品 -->
    <div class="pl-goods" ref="pl_goods">
        <div class="row">
            <div class="col-md-6">
                <input type="text" class="form-control" placeholder="请输入商品名称" v-model="pl_goods_name" @keyup.13="queryPlGoods" />
            </div>
            <div class="pull-right">
                <button type="button" class="btn btn-flat btn-small btn-orange" @click="queryPlGoods">查询</button>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered table-hover" data-pagination="true" ref="pl_goods_list"></table>
        </div>
    </div>
    <!-- 商品列表 > 添加商品弹窗 -->
    <div class="add-good" ref="add_good">
        <h5>商品条码【{{modify_bar_code1}}】匹配商品如下：</h5>
        <p>请选择适用商品，如以下商品不适用，请点击纠错后重新提交。</p>
        <div class="table-responsive">
            <table ref="add_good_table" class="table table-bordered table-hover" data-pagination="true"></table>
        </div>
    </div>
    <!-- 商品列表 > 选择云库商品 -->
    <div class="choose-cloud-good ele-hide" ref="choose_cloud_good">
        <div class="red-tip" v-show="'img'!=popType">选择云库商品后，系统将自动填写商品相关信息</div>
        <el-form :inline="true">
            <el-form-item label="商品名称">
                <el-input v-model="cloud_good_name" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品条码" class="relative">
                <el-input v-model="cloud_good_barcode" placeholder="请输入商品条码" clearable></el-input>
                <div class="red-tip" v-if="cloud_good_barcode && need_show_tip">系统已自动关联商品条码检索</div>
            </el-form-item>
            <el-button type="primary" @click="getCloudGoodsList(1)">查询</el-button>
        </el-form>
        <div class="goods-wrapper">
            <div class="item" v-for="item in cloud_goods" :key="item.id" @click="onCloudGoodsChoose(item)">
                <img :src="item.img_url" alt="" class="img">
                <div class="name">{{item.name}}<span v-if="item.goods_unit_name">/{{item.goods_unit_name}}</span></div>
                <div class="choose" :class="{'active': item.is_choosed}"></div>
            </div>
        </div>
        <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :page-size="cloud_page_size"
            :current-page.sync="cloud_page"
            :total="cloud_total"
            @current-change="getCloudGoodsList">
        </el-pagination>
    </div>
    <!-- 商品列表 > 查看大图 -->
    <div class="big-img" ref="big_img">
        <img :src="big_img_url" alt="">
    </div>
    <!-- 商品列表 > 纠错 -->
    <div class="feedback" ref="feedback">
        <p>纠错商品条码：{{modify_bar_code1}}</p>
        <span>纠错后您可以添加该条码商品，感谢您的支持！</span>
        <div class="feedback-txt">
            <textarea placeholder="请输入出错原因" v-model="feedback_reason"></textarea>
            <ul class="clearfix">
                <li @click="reasonCon('商品名称出错')">商品名称出错</li>
                <li @click="reasonCon('商品单位出错')">商品单位出错</li>
                <li @click="reasonCon('商品条码出错')">商品条码出错</li>
                <li @click="reasonCon('商品图片出错')">商品图片出错</li>
            </ul>
        </div>
        <div class="feedback-img">
            <h5>请上传正确商品图片</h5>
            <div>
                <img class="err-img" :src="err_url" @click="addErrImg()">
                <input type="file" class="err-input" @change="uploadErrImg($event)" ref="err_img" id="err_img" />
            </div>
        </div>
    </div>
    <!-- 商品列表 > 添加商品单位 -->
    <div class="add-unit" ref="add_unit">
        <div class="row rowpadding">
            <label class="col-md-3 control-label">商品单位:</label>
            <div class="col-md-9">
                <input class="form-control" placeholder="请输入商品单位" v-model="add_unit_name">
            </div>
        </div>
    </div>
    <!-- 商品列表 > 添加商品口味 -->
    <div class="add-taste" ref="add_taste">
        <div class="row rowpadding">
            <label class="col-md-3 control-label">商品口味:</label>
            <div class="col-md-9">
                <input class="form-control" placeholder="请输入商品口味" v-model="add_taste_name">
            </div>
        </div>
    </div>

</div>

</template>

<script>
import Vue from 'vue';
export default {
    name: '',
    data() {
        return {
            vip_shareholder_status: '',
            titShow: true,
            listShow1: false,
            listShow2: false,
            listShow3: false,
            shop_list: [],
            goods_type_list: [],


            // 11111111111111
            listPage: true,
            detPage: false,
            qrcodePage: false,
            codeNum: 2,
            paramsdatas: "",
            modify: 1,
            page_header: '新增商品',

            submitpage: false,
            modifypage: false,

            goods_name: "",
            shop_id: "",
            error_img: require('../../assets/images/upload.png'),
            send: '1',
            modify_bar_code1: "",
            modify_bar_code2: "",
            modify_bar_code3: "",
            modify_bar_code4: "",
            modify_bar_code5: "",
            modify_bar_code6: "",
            modify_bar_code7: "",
            bar_codes: [],
            adShopArr: [],
            shopSynDatas: [],
            cmdy_name: '',
            cmdy_nickname: '',
            cmdy_price: '',
            cmdy_disctprice: '',
            cmdy_viprice: '',
            vip_level1_price: '',
            vip_level2_price: '',
            vip_level3_price: '',
            vip_level4_price: '',
            vip_level5_price: '',
            vip_level6_price: '',
            vip_level7_price: '',
            vip_level8_price: '',
            vip_level9_price: '',
            vip_level10_price: '',
            cmdy_sequence: '',
            syn_allcheck: false,
            c_syn_allcheck: false,
            syn_checkboxModel: [],
            syn_checkboxData: [],
            syn_confirm_showed: false,
            tlist_allcheck: false,
            tlist_checkboxModel: [],
            tlist_checkboxData: [],
            flavors_info_formated: [],
            voucher_status: '-1', // 是否关联券，1：是，-1：否
            voucher_type: '1', // 1：巨嗨卡券，2：友宝售后机商品券
            voucher_id: '', // 关联的券id
            voucher_name: '', // 关联的券名
            card_type: [{
                id: '',
                text: '全部'
            }, {
                id: '1',
                text: '优惠券'
            }, {
                id: '2',
                text: '物品券'
            }, {
                id: '3',
                text: '商品套餐券'
            }, {
                id: '4',
                text: '开房套餐券'
            }],
            card_type_name: '', // 卡券名称
            query_voucher_name: '', // 关联券弹窗检索名称
            coupon_page: 1,
            coupon_page_size: 5,
            coupon_total: 0,
            coupon_list: [],
            pop_loading: false,
            choosedVoucher: {}, // 选择的关联券
            goodsListData: [],
            is_ingredients: false, // 是否配料商品
            ingredients_table: [], // 配料商品
            ingredients_pop_form: {
                goods_type: '',
                goods_name: '',
            },
            ingredients_pop_table: [], // 配料商品弹窗
            ingredients_pop_total: 0,
            ingredients_pop_page: 1, 
            choosedIngredients: [], // 选择的配料商品
            pl_goods_name: '',
            big_img_url: '',
            good_detail: {},
            imgs: [],
            video_url: '',
            uploaderList: [], // 上传插件实例
            submitimg1: require('../../assets/images/init1.png'),
            commodity_des: '',
            addname: "",
            modify_id: "",
            modify_img: "",
            modify_goods: "",
            modify_type: "",
            modify_unit: "",
            modify_shop: "",
            modify_cost_price: "",
            modify_discount_price: "",
            submit_goodsname: "",
            submit_note: "",
            err_url: require('../../assets/images/uld_btn.png'),
            feedback_reason: '',
            add_unit_name: '',
            add_taste_name: '',
            list_shop_cg: '',
            list_qrcode: '',
            export_allcheck: false,
            c_export_allcheck: false,
            export_checkModel: [],
            export_checkData: ['listorder', 'shop_name', 'barcodes', 'goods_name', 'goods_unit_name', 'goods_type_name', 'cost_price', 'discount_price', 'recommend', 'is_sell', 'status', 'guqing', 'vip_price', 'vip_level1_price', 'vip_level2_price', 'vip_level3_price', 'vip_level4_price', 'vip_level5_price', 'vip_level6_price', 'vip_level7_price', 'vip_level8_price', 'vip_level9_price', 'vip_level10_price'],
            export_type: 1,
            commodity_tc_numb: '',
            commodity_tc_perc: '',
            commodity_serv_perc: '',
            commodity_forecast_cost: '',
            commodity_gross_ratio: '',
            list_menu_add: false,
            list_menu_op: [{cls: 'text-blue status', name: '状态'}, {cls: 'text-blue qrcode', name: '二维码'}],
            list_menu_del: false,
            multi_del_form: {
                shop_id: '',
                goods_type: ''
            },

            cloud_good_name: '',
            cloud_good_barcode: '',
            cloud_page: 1,
            cloud_page_size: 10,
            cloud_total: 0,
            cloud_goods: [],
            choosed_cloud_good: null, // 选择的云库商品
            need_show_tip: true,
            popType: '',

            gme_txt: "",
            gme_all: false,
            c_gme_all: false,
            gme_item: [],
            gme_arr: [],
            gme_config_init: [{
                type: 'select',
                check: false,
                label: '是否赠送商品',
                key: 'is_present',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否消费者端显示',
                key: 'customer_show',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否允许打折',
                key: 'discount_status',
                value: '-1'
            }, {
                type: 'select',
                check: false,
                label: '是否算订台业绩',
                key: 'outstanding',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否为销售商品',
                key: 'is_sell',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否为推荐商品',
                key: 'recommend',
                value: '-1'
            }, {
                type: 'select',
                check: false,
                label: '是否属低消',
                key: 'is_minimum_consumption',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否盘点',
                key: 'available_stocking',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '优惠券是否可用',
                key: 'use_reward',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '会员账户可支付设置',
                key: 'vip_present_pay',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否适用会员积分抵扣金额',
                key: 'vip_points_pay',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否计入可赠送比例',
                key: 'included_give_ratio',
                value: '1'
            }, {
                type: 'input',
                label: '提成金额',
                key: 'deduct_amount',
                value: '',
                placeholder: '请输入商品提成金额',
                unit: '元'
            }, {
                type: 'input',
                label: '提成百分比',
                key: 'deduct_rate',
                value: '',
                placeholder: '请输入商品提成百分比',
                unit: '%'
            }, {
                type: 'input',
                label: '服务费收取比例',
                key: 'service_charge_rate',
                value: '',
                placeholder: '请输入服务费收取比例',
                unit: '%'
            }, {
                type: 'input',
                label: '预估成本价',
                key: 'forecast_cost_price',
                value: '',
                placeholder: '请输入预估成本价',
                unit: '元'
            }, {
                type: 'input',
                label: '毛利百分比',
                key: 'gross_margin_ratio',
                value: '',
                placeholder: '请输入毛利百分比',
                unit: '%'
            }, {
                type: 'select',
                check: false,
                label: '业绩提成属性',
                key: 'sales_commission',
                value: '1'
            }, {
                type: 'select',
                check: false,
                label: '是否配料商品',
                key: 'is_ingredients',
                value: '-1'
            }],
            gme_config: [],

            // 2222222222222222
            types_sort: '',
            types_name: '',
            types_menu_add: false,
            types_menu_op: [],

            // 3333333333333333
            taste_name: '',
            taste_menu_add: false,
            taste_menu_op: [],
        }
    },
    computed: {
        menu() {
            let menu = {};
            if(!$.isEmptyObject(this.$store.state.menunew)) {
                menu = JSON.parse(this.$store.state.menunew);
                $.each(menu, function(k, v) {
                    if(v.id == '542') {
                        menu = v.submenu;
                        $.each(menu, function(m, n) {
                            if(n.id == '549') {
                                menu = n.submenu;
                            }
                        });
                    }
                });
            }
            return menu;
        },
        isOnlineImg() {
            return this.submitimg1.includes("http") 
        },
        business_model() {
            return this.$store.state.business_model
        },
    },
    watch: {
        gme_txt: {
            handler: function(val, oldval) {
                if(val != "") {
                    $(this.$refs.gme_txt).parent().find('.selection-clear').show();
                } else {
                    $(this.$refs.gme_txt).parent().find('.selection-clear').hide();
                }
            },
            deep: true
        },
        gme_item: {
            handler: function(val, oldVal) {
                if(this.gme_item.length >= this.gme_arr.length) {
                    this.gme_all = true;
                    this.c_gme_all = true;
                } else {
                    this.gme_all = false;
                    this.c_gme_all = false;
                }
            },
            deep: true
        },

        export_checkModel: {
            handler: function(val, oldVal) {
                if(this.export_checkModel.length >= this.export_checkData.length) {
                    this.export_allcheck = true;
                    this.c_export_allcheck = true;
                } else {
                    this.export_allcheck = false;
                    this.c_export_allcheck = false;
                }
            },
            deep: true
        },

        syn_checkboxModel: {
            handler: function(val, oldVal) {
                if(this.syn_checkboxModel.length >= this.syn_checkboxData.length) {
                    this.syn_allcheck = true;
                    this.c_syn_allcheck = true;
                } else {
                    this.syn_allcheck = false;
                    this.c_syn_allcheck = false;
                }
            },
            deep: true
        },
        tlist_checkboxModel: {
            handler: function(val, oldVal) {
                let _this = this;
                if(_this.tlist_checkboxModel.length >= _this.tlist_checkboxData.length) {
                    _this.tlist_allcheck = true;
                } else {
                    _this.tlist_allcheck = false;
                }
                // let str = [],
                //     num = 1;
                // _this.tlist_checkboxModel.forEach(function(item) {
                //     _this.tlist_checkboxData.forEach(function(item2) {
                //         if(item2.id == item) {
                //             str.push('<li>'+ num +'、'+ item2.name +'</li>');
                //             num++;
                //         }
                //     });
                // });
                // $('.list-taste-sel ul').html(str.join(''));
            },
            deep: true
        },
        commodity_tc_numb: {
            handler: function(val, oldVal) {
                if(this.commodity_tc_numb != '') {
                    $(this.$refs.commodity_tc_perc).prop('disabled', true);
                } else {
                    $(this.$refs.commodity_tc_perc).prop('disabled', false);
                }
            },
            deep: true
        },
        commodity_tc_perc: {
            handler: function(val, oldVal) {
                if(this.commodity_tc_perc != '') {
                    $(this.$refs.commodity_tc_numb).prop('disabled', true);
                } else {
                    $(this.$refs.commodity_tc_numb).prop('disabled', false);
                }
            },
            deep: true
        },
    },
    mounted: function() {},
    created: function() {
        this.vip_shareholder_status = this.$store.state.privinfo.vip_shareholder_status
        this.getMenuOp()
    },
    methods: {
        // 获取权限
        getMenuOp() {
            let _this = this,
                menu = [];
            if(!$.isEmptyObject(this.$store.state.menunew)) {
                menu = JSON.parse(this.$store.state.menunew);
                $.each(menu, function(k, v) {
                    if(v.id == '542') {
                        menu = v.submenu;
                        $.each(menu, function(m, n) {
                            if(n.id == '549') {
                                menu = n.submenu;
                            }
                        });
                    }
                });

                menu.forEach(items => {
                    if(items.id == '752') {
                        _this.list_menu_op = [{cls: 'text-blue status', name: '状态'}, {cls: 'text-blue qrcode', name: '二维码'}];
                        items.submenu.forEach(_ => {
                            if(_.id == '782') {
                                _this.list_menu_add = true;
                            }
                            if(_.id == '783') {
                                _this.list_menu_op.unshift({cls: 'text-blue edit', name: '修改'});
                            }
                            if(_.id == '784') {
                                _this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
                                _this.list_menu_del = true
                            }
                        })
                    } else if(items.id == '753') {
                        _this.types_menu_op = [];
                        items.submenu.forEach(_ => {
                            if(_.id == '786') {
                                _this.types_menu_add = true;
                            }
                            if(_.id == '787') {
                                _this.types_menu_op.unshift({cls: 'text-blue edit', name: '修改'});
                            }
                            if(_.id == '788') {
                                _this.types_menu_op.push({cls: 'text-blue del', name: '删除'});
                            }
                        })
                    } else if(items.id == '754') {
                        _this.taste_menu_op = [];
                        items.submenu.forEach(_ => {
                            if(_.id == '790') {
                                _this.taste_menu_add = true;
                            }
                            if(_.id == '791') {
                                _this.taste_menu_op.unshift({cls: 'text-blue edit', name: '修改'});
                            }
                            if(_.id == '792') {
                                _this.taste_menu_op.push({cls: 'text-blue del', name: '删除'});
                            }
                        })
                    }
                })
            }
        },
        titClk: function(num) {
            var _this = this;
            _this.titShow = false;
            _this.listShow1 = false;
            _this.listShow2 = false;
            _this.listShow3 = false;

            if(num == '商品列表') {
                _this.getstoredata();
                _this.getcommoditypedata();
                $(_this.$refs.recommend_goods).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_recommended).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_recommended).val(-1).trigger("change");
                $(_this.$refs.commodity_giving).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_giving).val(1).trigger("change");
                $(_this.$refs.commodity_discount).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_discount).val(-1).trigger("change");
                $(_this.$refs.commodity_sale).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_sale).val(1).trigger("change");
                $(_this.$refs.gq_status).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.gq_ingredient).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_min).val(1).trigger("change");
                $(_this.$refs.commodity_min).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_pd).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_hz).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_cshow).val(1).trigger("change");
                $(_this.$refs.commodity_cshow).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_dt).val(1).trigger("change");
                $(_this.$refs.commodity_dt).select2({
                    allowClear: true,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_disc_use).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
                $(_this.$refs.commodity_hjd).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
                $(_this.$refs.commodity_kzb).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_kzb).val(1).trigger("change");
                $(_this.$refs.commodity_sales_commission).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_sales_commission).val(1).trigger("change");
                $(_this.$refs.commodity_sjsp).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
                $(_this.$refs.commodity_sjsp).val(-1).trigger("change");
                $(_this.$refs.commodity_ingredient).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                }).on("select2:select", function(e) {
                    if(e.params.data.id == '1' ) {                        
                        $('.list-img').hide();
                        $('.list-video').hide();
                        $('.list-syn').hide();
                        $('.list-taste').hide();
                        $('.list-coupon').hide();
                        $('.list-ingredients').hide()
                    }else {
                        $('.list-img').show();
                        $('.list-video').show();
                        $('.list-syn').show();
                        $('.list-taste').show();
                        $('.list-coupon').show();
                        $('.list-ingredients').show()
                    }
                });
                $(_this.$refs.commodity_ingredient).val(-1).trigger("change");
                // $(_this.$refs.gq_status).val(-1).trigger("change");
                _this.listShow1 = true;
            } else if(num == '商品类型') {
                _this.initTypesTable();
                $(_this.$refs.types_custm).select2({
                    language: "zh-CN",
                    minimumResultsForSearch: -1,
                    width: '100%'
                });
                _this.listShow2 = true;
            } else if(num == '商品口味') {
                _this.initTasteTable();
                _this.listShow3 = true;
            }
        },
        backTit: function() {
            this.titShow = true;
            this.listShow1 = false;
            this.listShow2 = false;
            this.listShow3 = false;
        },
        // 返回商品列表
        backList: function() {
            this.detPage = false;
            this.qrcodePage = false;
            this.listPage = true;
        },
        // 门店数据
        getstoredata: function() {
            let _this = this;

            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {}
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function(data) {
                    if(data['response']['result_code'] == "true") {
                        let shopDatas = [];
                        $.each(data['response']['result'], function(k, v) {
                            shopDatas.push({ id: v.id, text: v.name });
                        });
                        _this.shop_list = data.response.result
                        _this.shop_list.shift()
                        $(_this.$refs.shopbtn).select2({
                            data: shopDatas,
                            allowClear: true,
                            minimumResultsForSearch: -1,
                            language: "zh-CN",
                            width: '100%'
                        }).on("select2:select", function(e) {
                            _this.shop_id = e.params.data.id;
                        });
                        $(_this.$refs.shopbtn).val(shopDatas[1].id).trigger('change');
                        _this.innitable();

                        _this.adShopArr = shopDatas;
                        _this.adShopArr.splice(0, 1);

                        $(_this.$refs.gme_shop).select2({
                            data: _this.adShopArr,
                            minimumResultsForSearch: -1,
                            width: '100%'
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function(err) {

                }
            });
        },
        // 商品类型
        getcommoditypedata :function() {
            var _this = this;
            var commdatas = [{ id: " ", text: "全部" }];
            var elsecommdatas = [];
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {}
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getGoodsType",
                async: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function(data) {
                    if(data['response']['result_code']=="true"){
                        $.each(data['response']['result']['data'], function(k, v) {
                            commdatas.push({ id: v.id, text: v.name });
                            elsecommdatas.push({ id: v.id, text: v.name });
                        });
                        _this.goods_type_list = data.response.result.data

                        _this.gme_arr = data['response']['result']['data'];
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function(err) {

                }
            });
            $(_this.$refs.commodity_type).select2({
                data: commdatas,
                allowClear: true,
                minimumResultsForSearch: -1,
                language: "zh-CN"
            });
            $(_this.$refs.add_type_option).select2({
                data: elsecommdatas,
                allowClear: true,
                language: "zh-CN"
            });
            $(_this.$refs.commodity_detailtype).select2({
                data: elsecommdatas,
                minimumResultsForSearch: -1
            });
        },
        // 清空多选
        clearInput: function() {
            this.gme_txt = '';
            this.gme_item = [];
        },
        // 初始化列表
        innitable: function() {
            let _this = this;
            var actionEvents= {
                'click .edit': function(e, value, row, index) {
                    _this.page_header = '修改商品';
                    _this.modify = 2;
                    _this.syn_confirm_showed = false

                    // 可编辑
                    $(_this.$refs.modify_bar_code1).prop('disabled', false);
                    $(_this.$refs.modify_bar_code2).prop('disabled', false);
                    $(_this.$refs.modify_bar_code3).prop('disabled', false);
                    $(_this.$refs.modify_bar_code4).prop('disabled', false);
                    $(_this.$refs.modify_bar_code5).prop('disabled', false);
                    $(_this.$refs.modify_bar_code6).prop('disabled', false);
                    $(_this.$refs.modify_bar_code7).prop('disabled', false);
                    $(_this.$refs.list_next).addClass('btn-hide');
                    $(_this.$refs.list_sub).removeClass('btn-hide');
                    $(_this.$refs.cmdy_name).prop('disabled', false);
                    $(_this.$refs.commodity_unit).prop('disabled', false);

                    $('.list-base').show();
                    $('.list-other').show();
                    $('.list-img').show();
                    $('.list-video').show();
                    $('.list-syn').show();
                    $('.list-taste').show();
                    $('.list-coupon').show();
                    $('.list-ingredients').show();
                    _this.listPage = false;
                    _this.detPage = true;
                    _this.getGoodDetail(row.id);
                },
                'click .status': function(e, value, row, index) {
                    _this.modify_id = row.id;
                    var statuscode = (row.status == 1) ? -1 : 1;
                    _this.updatedata(statuscode);
                },
                'click .qrcode': function(e, value, row, index) {
                    _this.list_shop_cg = row.shop_name;
                    _this.list_qrcode = row.qrcode_url + '&fill_in_room=3';

                    // 配送包厢必填
                    $(_this.$refs.cmdy_qr_box).val('').trigger('change');
                    $(_this.$refs.cmdy_qr_box).select2({
                        width: '100%',
                        minimumResultsForSearch: -1,
                        language: "zh-CN",
                    }).on("select2:select", function(e) {
                        _this.list_qrcode = row.qrcode_url + '&fill_in_room='+ e.params.data.id +'';
                    });

                    _this.listPage = false;
                    _this.qrcodePage = true;
                },
                'click .del': function(e, value, row, index) {
                    layer.confirm('删除后不可恢复，确定删除吗？', {
                        btn: ['确定', '取消']
                    }, function() {
                        _this.modify_id = row.id;
                        _this.updatedata(-2);
                    });
                }
            };
            //$(this.$refs.commodity_manage_table).bootstrapTable('destroy');
            $(this.$refs.commodity_manage_table).bootstrapTable({
                pageSize: 10,
                pageList: [],
                ajax: function(params) {
                    _this.paramsdatas = params;
                    _this.getcommoditydata(params);
                },
                sidePagination: "server",
                pagination: true,
                columns: [{
                    width: "5%",
                    field: "listorder",
                    title: "显示<br />顺序",
                    valign: "middle"
                }, {
                    width: "8%",
                    field: "shop_name",
                    title: "门店",
                    valign: "middle"
                }, {
                    width: "8%",
                    field: "good_img",
                    title: "商品图片",
                    valign: "middle",
                    formatter: function(value, row) {
                        var src = "this.src='" + _this.error_img + "'";
                        return '<img class="imglogo" src="' + value + '" onerror="'+src+'">';
                    }
                }, {
                    width: "8%",
                    field: "goods_name",
                    title: "商品别名",
                    valign: "middle"
                }, {
                    width: "8%",
                    field: "goods_unit_name",
                    title: "商品单位",
                    valign: "middle"
                }, {
                    width: "7%",
                    field: "goods_type_name",
                    title: "商品类型",
                    valign: "middle"
                }, {
                    width: "7%",
                    field: "cost_price",
                    title: "原价",
                    valign: "middle"
                }, {
                    width: "6%",
                    field: "discount_price",
                    title: "优惠价",
                    valign: "middle"
                }, {
                    width: "5%",
                    field: "recommend",
                    title: "推荐<br />商品",
                    valign: "middle",
                    formatter: function(value, row) {
                        value = value == "-1" ? "否" : "是";
                        return value;
                    }
                }, {
                    field: "is_sell",
                    title: "销售<br />商品",
                    width: "5%",
                    valign: "middle",
                    formatter: function(value, row, index) {
                        if(row.is_sell == 1) {
                            return '是';
                        } else if(row.is_sell == -1) {
                            return '否';
                        }
                    }
                }, {
                    width: "5%",
                    field: "status",
                    title: "状态",
                    valign: "middle",
                    formatter: function(value, row) {
                        value = (value == "1") ? "启用" : "禁用";
                        return value;
                    }
                }, {
                    width: "5%",
                    field: "guqing",
                    title: "估清<br />状态",
                    valign: "middle",
                    formatter: function(value, row) {
                        value = (value == "1") ? "估清" : "未估清";
                        return value;
                    }
                }, {
                    width: "12%",
                    title: "操作",
                    valign: "middle",
                    events: actionEvents,
                    // formatter: _this.actionFormatter,
                    formatter: function(value, row, index) {
                        let statustext = (row.status == 1) ? '禁用' : '启用';
                        let op_html = '';
                        $.each(_this.list_menu_op, function(k, v) {
                            if(v.name == '状态') {
                                op_html += '<span class="'+ v.cls +'">'+ statustext +'</span>&nbsp;&nbsp;';
                            } else {
                                op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
                            }
                        });
                        return op_html;
                    }
                }],
            });
        },
        // // 操作列格式化
        // actionFormatter: function(value, row, index) {
        //     var statustext = (row.status == 1) ? '禁用' : '启用';
        //     return [
        //         '<div class="orange-text">',
        //             '<a class="edit">修改</a>',
        //             '<a class="status">&nbsp;'+statustext+'</a><br />',
        //             '<a class="qrcode">二维码</a>',
        //             '<a class="del">删除</a>',
        //         '</div>'
        //     ].join('');
        // },
        // 列表数据
        getcommoditydata: function(params, discount_price) {
            var _this = this;
            var pageNumber = 1;
            var shop_id, shop_name;
            if(params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            var recommend = $(_this.$refs.recommend_goods).val();
            var suggestvuele = $(_this.$refs.shopbtn).val();
            var goods_type = $.trim($(_this.$refs.commodity_type).val());
            // if(suggestvuele==this.selectshopname){
              // shop_id=this.shop_id;
            shop_id = $(_this.$refs.shopbtn).val();
            // }else{
            shop_name = '';
            // }
            var layIndex = layer.load(0, {
                shade: [0.1, '#ececec']
            });
            var goods_name = this.goods_name;
            if(_this.send == '1') {
                var datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": pageNumber,
                            "page_size": "10",
                            "shop_id": shop_id || "",
                            "shop_name": shop_name || "",
                            "goods_type": goods_type || "",
                            "goods_name": goods_name || "",
                            "recommend": recommend || "",
                            "is_sell": $(_this.$refs.actual_sale).val(),
                            "status": $(_this.$refs.recommend_status).val(),
                            "guqing": $(_this.$refs.gq_status).val(),
                            "is_ingredients": $(_this.$refs.gq_ingredient).val(),
                        }
                    },
                    "comment": ""
                };
            } else if(_this.send == '0') {
                var datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": pageNumber,
                            "page_size": "10",
                            "shop_id": shop_id || "",
                            "shop_name": shop_name || "",
                            "goods_type": goods_type || "",
                            "goods_name": goods_name || "",
                            "recommend": recommend || "",
                            "is_sell": $(_this.$refs.actual_sale).val(),
                            "status": $(_this.$refs.recommend_status).val(),
                            "guqing": $(_this.$refs.gq_status).val(),
                            "discount_price": _this.send,
                            "is_ingredients": $(_this.$refs.gq_ingredient).val(),
                        }
                    },
                    "comment": ""
                };
                // this.send = '1';
            }
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function(data) {
                    if(data['response']['result_code'] == "true") {
                        params.success({
                            total: data['response']['result']['data']['total'],
                            rows: data['response']['result']['data']['rows']
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data["response"]["error_msg"]);
                        params.success({
                            total: 0,
                            rows: []
                        });
                    }
                    layer.close(layIndex);
                },
                error: function(err) {
                    layer.close(layIndex);
                }
            });
        },
        // 查询
        maintablesearch: function() {
            // $(this.$refs.commodity_manage_table).bootstrapTable('refreshOptions',{pageNumber:1});
            this.send = '1';
            $(this.$refs.commodity_manage_table).bootstrapTable("destroy");
            this.innitable();
        },
        // 查看0元商品
        zeroSearch: function() {
            this.send = '0';
            // $(this.$refs.commodity_manage_table).bootstrapTable('refreshOptions', {pageNumber:1});
            $(this.$refs.commodity_manage_table).bootstrapTable("destroy");
            this.innitable();
        },
        // 商品批量修改
        multiServRate: function() {
            let _this = this;

            $(_this.$refs.gme_shop).val('').trigger('change');
            _this.gme_txt = "";
            _this.gme_config = []
            _this.gme_config_init.forEach(v => {
                _this.gme_config.push({...v})
            })
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'],
                title: ['商品批量修改', true],
                area: ['700px', '500px'],
                content: $(_this.$refs.goods_multi_edit),
                offset: '100px'
            }, function() {
                let config = {}
                _this.gme_config.forEach(v => {
                    if(v.check) {
                        config[v.key] = v.value
                    }
                })
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": $(_this.$refs.gme_shop).val(),
                            "goods_type": _this.gme_item,
                            "config": config
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "MerchantGoods/batchUpdateMerchantGoods",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg("操作成功");
                            $(_this.$refs.commodity_manage_table).bootstrapTable("refresh");
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },
        // 点击选择商品类型
        openGoodtype: function(e) {
            let _this = this;
            let c_gme_item = _this.gme_item;
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['商品类型', true],
                area: ['600px', ''], //宽高
                content: $(_this.$refs.gme_alert),
                cancel: function() {
                    // 右上角关闭
                    if(_this.gme_txt != "") {
                        _this.gme_item = c_gme_item;
                        return;
                    }
                    _this.gme_item = [];
                }
            }, function() {
                let texts = [];
                _this.gme_arr.forEach(function(item) {
                    _this.gme_item.forEach(function(item2) {
                        if(item.id == item2) {
                            texts.push(item.name);
                        }
                    });
                });
                _this.gme_txt = texts.join(",");
                layer.close(layer.index);
            }, function() {
                if(_this.gme_txt != "") {
                    _this.gme_item = c_gme_item;
                    return;
                }
                _this.gme_item = [];
            });
        },
        // 商品类型全选
        servRateCheckAll: function() {
            let _this = this;
            _this.gme_all = _this.c_gme_all;
            if(!_this.gme_all) { // 实现全选
                _this.gme_item = [];
                _this.gme_arr.forEach(function(item) {
                    _this.gme_item.push(item.id);
                });
            } else { // 实现反选
                _this.gme_item = [];
            }
        },
        // 获取导出设置
        getExportSet: function() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "report_type": "merchantGoods/merchantGoodsListExport"
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "FinanceReport/getExportSet",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        if(data.response.result) {
                            _this.export_checkModel = data.response.result.export_fields;
                            _this.export_type = data.response.result.export_type;
                        } else {
                            _this.export_checkModel = _this.export_checkData;
                            _this.export_type = 1;
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });

            // 弹窗
            layer.confirm('', {
                skin: 'add_printer_area',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['导出设置', true],
                area: ['830px', ''], // 宽高
                content: $(_this.$refs.export_alert)
            }, function() {
                _this.exportList();
            });
        },
        // 导出字段全选
        exportCheckedAll: function() {
            let _this = this;
            _this.export_allcheck = _this.c_export_allcheck;
            if(!_this.export_allcheck) { // 实现全选
                _this.export_checkModel = [];
                _this.export_checkData.forEach(function(item) {
                    _this.export_checkModel.push(item);
                });
            } else { // 实现反选
                _this.export_checkModel = [];
            }
        },
        // 导出
        exportList: function() {
            var _this = this;
            // if($(_this.$refs.shopbtn).attr('data-id') == '') {
            //     layer.msg('请选择门店');
            //     return false;
            // }
            // let pageNumber = 1;
            // if(params.data.offset != 0) {
            //     pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            // }
            let goods_name = $.trim(_this.goods_name) || '';
            let export_fields = JSON.stringify(_this.export_checkModel);

            if(_this.send == '0') {
                window.location.href = Vue.ctUrl + "merchantGoods/merchantGoodsListExport?" + "shop_id=" + $(_this.$refs.shopbtn).val() +
                    "&goods_type=" +  $.trim($(_this.$refs.commodity_type).val()) +
                    "&recommend=" + $(_this.$refs.recommend_goods).val() +
                    "&is_sell=" + $(_this.$refs.actual_sale).val() +
                    "&status=" + $(_this.$refs.recommend_status).val() +
                    "&guqing=" + $(_this.$refs.gq_status).val() +
                    "&is_ingredients=" + $(_this.$refs.gq_ingredient).val() +
                    "&goods_name=" + goods_name +
                    "&discount_price=" + _this.send +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.export_type;
            } else {
                window.location.href = Vue.ctUrl + "merchantGoods/merchantGoodsListExport?" + "shop_id=" + $(_this.$refs.shopbtn).val() +
                    "&goods_type=" + $.trim($(_this.$refs.commodity_type).val()) +
                    "&recommend=" + $(_this.$refs.recommend_goods).val() +
                    "&is_sell=" + $(_this.$refs.actual_sale).val() +
                    "&status=" + $(_this.$refs.recommend_status).val() +
                    "&guqing=" + $(_this.$refs.gq_status).val() +
                    "&is_ingredients=" + $(_this.$refs.gq_ingredient).val() +
                    "&goods_name=" + goods_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.export_type;
            }
            //debugger;
            layer.msg("导出成功！");
            layer.closeAll();
        },
        // 点击新增商品
        addCommodity: function() {
            let _this = this;

            _this.page_header = '新增商品';
            _this.modify = 1;
            $('.list-base').show();
            $('.list-other').show();
            $('.list-img').show();
            $('.list-video').show();
            $('.list-syn').show();
            $('.list-taste').show();
            $('.list-coupon').show();
            $('.list-ingredients').show();

            // 条形码
            _this.modify_bar_code1 = '';
            _this.modify_bar_code2 = '';
            _this.modify_bar_code3 = '';
            _this.modify_bar_code4 = '';
            _this.modify_bar_code5 = '';
            _this.modify_bar_code6 = '';
            _this.modify_bar_code7 = '';
            $('.bar-code-2').addClass('bar-code-hide');
            $('.bar-code-3').addClass('bar-code-hide');
            $('.bar-code-4').addClass('bar-code-hide');
            $('.bar-code-5').addClass('bar-code-hide');
            $('.bar-code-6').addClass('bar-code-hide');
            $('.bar-code-7').addClass('bar-code-hide');
            $(_this.$refs.modify_bar_code1).prop('disabled', false);
            $(_this.$refs.modify_bar_code2).prop('disabled', false);
            $(_this.$refs.modify_bar_code3).prop('disabled', false);
            $(_this.$refs.modify_bar_code4).prop('disabled', false);
            $(_this.$refs.modify_bar_code5).prop('disabled', false);
            $(_this.$refs.modify_bar_code6).prop('disabled', false);
            $(_this.$refs.modify_bar_code7).prop('disabled', false);

            // 请求门店
            _this.getstoredata();
            // 基本资料
            $(_this.$refs.add_shop).prop('disabled', false);
            $(_this.$refs.add_shop).val('').trigger('change');
            $(_this.$refs.add_shop).select2({
                data: _this.adShopArr,
                minimumResultsForSearch: -1,
                width: '100%'
            }).on("select2:select", function(e) {
                // 请求门店
                _this.getstoredata();
                // 资料同步
                _this.shopSynDatas = _this.adShopArr;
                $.each(_this.shopSynDatas, function(k, v) {
                    if(e.params.data.id == v.id) {
                        _this.shopSynDatas.splice(k, 1);
                        _this.syn_checkboxData = _this.shopSynDatas;
                        _this.syn_checkboxModel = [];
                        return false;
                    }
                });
            });
            $(_this.$refs.cmdy_name).prop('disabled', false);
            _this.cmdy_name = '';
            _this.cmdy_nickname = '';
            $(_this.$refs.commodity_unit).val("").trigger("change");
            $(_this.$refs.commodity_unit).prop('disabled', false);
            _this.getGoodsUnit();
            $(_this.$refs.commodity_detailtype).val("").trigger("change");
            _this.cmdy_price = '';
            _this.cmdy_disctprice = '';
            _this.cmdy_viprice = '';
            _this.vip_level1_price = '';
            _this.vip_level2_price = '';
            _this.vip_level3_price = '';
            _this.vip_level4_price = '';
            _this.vip_level5_price = '';
            _this.vip_level6_price = '';
            _this.vip_level7_price = '';
            _this.vip_level8_price = '';
            _this.vip_level9_price = '';
            _this.vip_level10_price = '';
            _this.cmdy_sequence = '';
            // 其他资料
            $(_this.$refs.commodity_giving).val(1).trigger("change");
            $(_this.$refs.commodity_discount).val(-1).trigger("change");
            $(_this.$refs.commodity_sale).val(1).trigger("change");
            $(_this.$refs.commodity_recommended).val(-1).trigger("change");
            $(_this.$refs.commodity_min).val(1).trigger("change");
            $(_this.$refs.commodity_pd).val('').trigger("change");
            $(_this.$refs.commodity_hz).val(1).trigger("change");
            $(_this.$refs.commodity_cshow).val(1).trigger("change");
            $(_this.$refs.commodity_dt).val(1).trigger("change");
            $(_this.$refs.commodity_disc_use).val('').trigger("change");
            $(_this.$refs.commodity_hjd).val('').trigger("change");
            $(_this.$refs.commodity_kzb).val(1).trigger("change");
            $(_this.$refs.commodity_sales_commission).val(1).trigger("change");
            $(_this.$refs.commodity_sjsp).val(-1).trigger("change");
            $(_this.$refs.commodity_ingredient).val(-1).trigger("change");
            _this.commodity_tc_numb = '';
            _this.commodity_tc_perc = '';
            _this.commodity_serv_perc = '';
            _this.commodity_forecast_cost = '';
            _this.commodity_gross_ratio = '';

            // 图片
            _this.submitimg1 = require('../../assets/images/init1.png');
            _this.commodity_des = '';

            // 视频
            _this.video_url = '';

            // 资料同步
            _this.shopSynDatas = _this.adShopArr;
            _this.shopSynDatas.splice(0, 1);
            _this.syn_checkboxData = _this.shopSynDatas;
            _this.syn_checkboxModel = [];

            // 商品口味
            _this.getTlistData();
            _this.tlist_checkboxModel = [];
            // let blank_flavor = [{
            //     flavor_type: '',
            //     data: [],
            //     flavors_str: '',
            //     flavors_id: []
            // }]
            _this.$set(_this.good_detail,'flavors_info', []);
            // 商品关联券
            _this.voucher_status = '-1'
            _this.voucher_type = ''
            _this.voucher_id = ''
            _this.voucher_name = ''
            // 配料商品
            _this.ingredients_table = [];


            // 纠错
            _this.err_url = require('../../assets/images/uld_btn.png');

            _this.listPage = false;
            _this.detPage = true;
        },
        // 点击上传xls文件
        addXlsFun: function() {
            this.$refs.cmdyXlsFile.click();
        },
        // 上传
        uploadCmdyXls: function(e) {
            let _this = this;

            let formData = new FormData();
            formData.append("goodsFile", $("#cmdyXlsFile")[0].files[0]);
            // 清除file
            let obj = document.getElementById('cmdyXlsFile');
            obj.value = '';

            $.ajax({
                type: "post",
                dataType: "json",
                processData: false,
                contentType: false,
                url: Vue.ctUrl + "merchantGoods/importGoods",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: formData,
                success: function(data) {
                    if(data.response.result_code == "true") {
                        layer.msg('导入成功');
                        $(_this.$refs.commodity_manage_table).bootstrapTable('refresh');
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.open({
                            type: 1,
                            title: '导入失败，数据错误，请修正数据后重新导入！',
                            skin: 'import-err',
                            area: ['700px', ''],
                            content: data.response.error_msg
                        })
                    }
                },
                error: function(err) {
                    layer.msg("网络原因");
                }
            });
        },
        // 商品批量删除
        cmdyMutilDel: function() {
            const _this = this;

            _this.multi_del_form = {
                shop_id: _this.shop_list[0].id,
                goods_type: ''
            }
            layer.confirm('', {
                type: 1,
                skin: 'public-alert-skin',
                btn: ['确定', '取消'], // 按钮
                title: '商品批量删除',
                area: ['550px', ''], // 宽高
                content: $(_this.$refs.cmdy_multi_del)
            }, function() {
                Vue.axios.post('merchantGoods/batchDeleteMerchantGoods', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.multi_del_form.shop_id,
                            "goods_type": _this.multi_del_form.goods_type
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.closeAll()
                        layer.msg('删除成功')
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
            });
        },
        // 添加条形码
        addBarCode: function() {
            if(this.modify != 2 && $(this.$refs.list_next).hasClass('btn-hide')) {
                return;
            }

            if($('.bar-code-2').hasClass('bar-code-hide')) {
                $('.bar-code-2').removeClass('bar-code-hide');
            } else if($('.bar-code-3').hasClass('bar-code-hide')) {
                $('.bar-code-3').removeClass('bar-code-hide');
            } else if($('.bar-code-4').hasClass('bar-code-hide')) {
                $('.bar-code-4').removeClass('bar-code-hide');
            } else if($('.bar-code-5').hasClass('bar-code-hide')) {
                $('.bar-code-5').removeClass('bar-code-hide');
            } else if($('.bar-code-6').hasClass('bar-code-hide')) {
                $('.bar-code-6').removeClass('bar-code-hide');
            } else if($('.bar-code-7').hasClass('bar-code-hide')) {
                $('.bar-code-7').removeClass('bar-code-hide');
            } else {
                layer.msg('最多添加7个条形码');
            }
        },
        // 删除条形码
        delBarCode: function(e, num) {
            if(this.modify != 2 && $(this.$refs.list_next).hasClass('btn-hide')) {
                return;
            }
            if(num == 2) {
                this.modify_bar_code2 = '';
            } else if(num == 3) {
                this.modify_bar_code3 = '';
            } else if(num == 4) {
                this.modify_bar_code4 = '';
            } else if(num == 5) {
                this.modify_bar_code5 = '';
            } else if(num == 6) {
                this.modify_bar_code6 = '';
            } else if(num == 7) {
                this.modify_bar_code7 = '';
            }
            $(e.currentTarget).parent().addClass('bar-code-hide');
        },

        // 获取云库商品列表
        getCloudGoodsList: function (page, needOpenPop, popType) {
            let _this = this;
            _this.cloud_page = page;
            _this.popType = popType;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "name": _this.cloud_good_name, // 商品名称搜索
                        "bar_code": _this.cloud_good_barcode, // 条形码搜索
                        "page": page,
                        "page_size": _this.cloud_page_size
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "platformGoods/searchPlatformGoodsList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                async: false,
                data: datas,
                success: function (data) {
                    if (data.response.result_code == "true") {
                        _this.cloud_total = Number(data.response.result.data.total);
                        _this.cloud_goods = data.response.result.data.rows;
                        if (_this.cloud_goods.length > 0 && needOpenPop) {
                            if(popType == 'img') {
                                _this.openCloudImgPop()
                            }else {
                                _this.openCloudGoodPop()
                            }
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function (err) {

                }
            });
        },

        // 选择云库商品
        onCloudGoodsChoose(item) {
            this.cloud_goods.forEach(item => {
                this.$set(item, 'is_choosed', false);
            });
            this.$set(item, 'is_choosed', true);
            this.choosed_cloud_good = item;
        },  

        // 打开云库商品选择弹窗
        openCloudGoodPop() {
            let _this = this;
            layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['选择云库商品', true],
                area: ['800px', ''], //宽高
                content: $(this.$refs.choose_cloud_good),
                offset: '100px'
            }, function () {
                if (_this.choosed_cloud_good) {
                    // 商品名称
                    _this.cmdy_name = _this.choosed_cloud_good.name;
                    $(_this.$refs.cmdy_name).prop('disabled', true);
                    // 商品别名
                    _this.cmdy_nickname = _this.choosed_cloud_good.name;
                    // 商品单位
                    $(_this.$refs.commodity_unit).val(_this.choosed_cloud_good.goods_unit).trigger('change');
                    $(_this.$refs.commodity_unit).prop('disabled', true);
                    // 图片
                    _this.submitimg1 = _this.choosed_cloud_good.img_url;
                    $('.defaultimage1').attr('suc', '1');
                    layer.closeAll();
                } else {
                    layer.msg('请选择商品');
                }
            })
        },

        // 条形码失去焦点
        onBarcodeBlur() {
            if(this.modify_bar_code1 == '') {
                return
            }
            this.cloud_good_name = '';
            this.cloud_good_barcode = this.modify_bar_code1
            this.cloud_page = 1;
            this.cloud_goods = [];
            this.choosed_cloud_good = null;
            this.need_show_tip = true;
            this.getCloudGoodsList(1, true)
        },

        // 点击商品名称“+”
        onAddIconClick() {
            this.cloud_good_name = '';
            this.cloud_good_barcode = '';
            this.cloud_page = 1;
            this.cloud_goods = [];
            this.choosed_cloud_good = null;
            this.need_show_tip = false;
            this.getCloudGoodsList(1, true)
        },

        // 点击“图库选择”
        chooseCloudImg() {
            this.cloud_good_name = '';
            this.cloud_good_barcode = '';
            this.cloud_page = 1;
            this.cloud_goods = [];
            this.choosed_cloud_good = null;
            this.need_show_tip = false;
            this.getCloudGoodsList(1, true, 'img')
        },

        // 打开云库商品选择图片弹窗
        openCloudImgPop() {
            let _this = this;
            layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['选择图片', true],
                area: ['800px', ''], //宽高
                content: $(this.$refs.choose_cloud_good),
                offset: '100px'
            }, function () {
                if (_this.choosed_cloud_good) {
                    // 图片
                    _this.submitimg1 = _this.choosed_cloud_good.img_url;
                    $('.defaultimage1').attr('suc', '1');
                    layer.closeAll();
                } else {
                    layer.msg('请选择商品图片');
                }
            })
        },

        // 下一步
        listNext: function() {
            let _this = this;

            if($(_this.$refs.list_next).hasClass('btn-hide')) {
                return;
            }

            $(_this.$refs.modify_bar_code1).prop('disabled', true);
            $(_this.$refs.modify_bar_code2).prop('disabled', true);
            $(_this.$refs.modify_bar_code3).prop('disabled', true);
            $(_this.$refs.modify_bar_code4).prop('disabled', true);
            $(_this.$refs.modify_bar_code5).prop('disabled', true);
            $(_this.$refs.modify_bar_code6).prop('disabled', true);
            $(_this.$refs.modify_bar_code7).prop('disabled', true);

            $('.list-base').show();
            $('.list-other').show();
            $('.list-img').show();
            $('.list-video').show();
            $('.list-syn').show();
            $('.list-taste').show();
            $('.list-coupon').show();
            $('.list-ingredients').show();

            // 资料同步是否显示
            if(_this.syn_checkboxData.length != '') {
                $('.list-syn').show();
            } else {
                $('.list-syn').hide();
            }

            // 删除图片属性
            $('.defaultimage1').removeAttr('suc');

            // 初始化视频上传
            _this.videoUpload('video-wrapper')

            _this.inniGood();
            if(_this.goodsListData.length > 0 && _this.modify_bar_code1 != '') {
                layer.confirm('', {
                    skin: 'add_goods-alert',
                    type: 1,
                    btn: ['确定', '纠错'], //按钮
                    title: ['选择云库商品', true],
                    area: ['700px', ''], //宽高
                    content: $(this.$refs.add_good),
                    offset: '100px'
                }, function() {
                    let arr = $(_this.$refs.add_good_table).bootstrapTable('getAllSelections');
                    if(arr.length > 0) {
                        // 商品名称
                        _this.cmdy_name = arr[0].name;
                        $(_this.$refs.cmdy_name).prop('disabled', true);
                        // 商品单位
                        $(_this.$refs.commodity_unit).val(arr[0].goods_unit).trigger('change');
                        $(_this.$refs.commodity_unit).prop('disabled', true);
                        // 图片
                        _this.submitimg1 = arr[0].img_url;
                        layer.closeAll();
                    } else {
                        layer.msg('请选择商品');
                    }
                }, function() {
                    _this.feedback_reason = '';
                    layer.confirm('', {
                        skin: 'add_goods-alert',
                        type: 1,
                        btn: ['确定', '取消'], //按钮
                        title: ['纠错原因', true],
                        area: ['700px', ''], //宽高
                        content: $(_this.$refs.feedback),
                        offset: '100px',
                        cancel: function() {
                            $(_this.$refs.list_next).removeClass('btn-hide');
                            _this.listNext();
                        }
                    }, function() {
                        // 提交纠错
                        let imgs = [];
                        if($('.err-img').attr('suc') == '1') {
                            imgs.push(_this.err_url);
                        }
                        let datas = {
                            "header": Vue.request_header,
                            "request": {
                                "param": {
                                    "bar_code": _this.modify_bar_code1, // 条形码
                                    "reason": _this.feedback_reason,
                                    "imgs": imgs
                                }
                            },
                            "comment": ""
                        };
                        datas = JSON.stringify(datas);
                        $.ajax({
                            type: "POST",
                            dataType: "json",
                            url: Vue.ctUrl + "platformGoods/addErrorCorrection",
                            crossDomain: true,
                            xhrFields: {
                                withCredentials: true
                            },
                            async: false,
                            data: datas,
                            success: function(data) {
                                if(data['response']['result_code'] == "true") {
                                    layer.msg(data["response"]["error_msg"]);
                                    layer.closeAll();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data["response"]["error_msg"]);
                                }
                            },
                            error: function(err) {
                                layer.msg('提交时出错');
                            }
                        });
                    }, function() {
                        $(_this.$refs.list_next).removeClass('btn-hide');
                        _this.listNext();
                    });
                });
            }

            $(_this.$refs.list_next).addClass('btn-hide');
            $(_this.$refs.list_sub).removeClass('btn-hide');
        },
        // 初始化商品列表
        inniGood: function() {
            var _this = this;
            $(_this.$refs.add_good_table).bootstrapTable('destroy');
            $(_this.$refs.add_good_table).bootstrapTable({
                pageSize: 4,
                pageList: [],
                ajax: function(params) {
                    _this.getGoodList(params);
                },
                sidePagination: "server",
                pagination: true,
                rowStyle: function() {
                    return {
                        css: {"line-height": "45px"}
                    };
                },
                columns: [{
                    width: "50%",
                    field: "img_url",
                    title: "商品图片",
                    events: {
                        'click .bigimg': function (e, value, row, index) {
                            _this.big_img_url = row.img_url;
                            layer.confirm('', {
                                skin: 'big-img-skin',
                                type: 1,
                                title: [row.name, true],
                                area: ['500px', ''], //宽高
                                content: $(_this.$refs.big_img),
                                offset: '100px'
                            });
                        }
                    }, 
                    formatter: function(value, row) {
                        return '<img src="' + row.img_url + '" style="width: 60px; height: 60px;"><span class="bigimg" style="margin: 0 0 0 37px; color: #009af0; cursor: pointer;">查看大图</span>';
                    }
                }, {
                    width: "20%",
                    field: "name",
                    title: "商品名称"
                }, {
                    width: "10%",
                    field: "goods_unit_name",
                    title: "商品单位"
                }, {
                    width: "10%",
                    field: "state",
                    title: "操作",
                    radio: true
                }],
            });
        },
        // 获取商品列表数据
        getGoodList: function(params) {
            let _this = this;
            let pageNumber = 1;
            if(params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "bar_code": _this.modify_bar_code1, // 条形码搜索
                        "page": pageNumber,
                        "page_size": '4'
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "platformGoods/searchPlatformGoodsList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                async: false,
                data: datas,
                success: function(data) {
                    if(data['response']['result_code'] == "true") {
                        params.success({
                            total: data['response']['result']['data']['total'],
                            rows: data['response']['result']['data']['rows']
                        });
                        _this.goodsListData = data['response']['result']['data']['rows'];
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function(err) {

                }
            });
        },
        // 修改页的提示语
        hint_language: function(e, num) {
            var contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
            layer.tips(contents, $(e.currentTarget), {
                skin: 'hint_language_tip',
                tips: [num, '#fff'],
                area: ['400px', ''],
                time: 2000000,
            });
        },
        // 关闭提示语
        close_hint_language: function() {
            layer.closeAll('tips');
        },
        // 商品单位数据
        getGoodsUnit: function() {
            var _this = this;
            var unitdata = [];
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "type":"1"
                    }
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "PublicData/api_getGoodsUnit",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function(data) {
                    if(data['response']['result_code'] == "true"){
                        $.each(data['response']['result']['data'], function(k, v) {
                            unitdata.push({ id: v.id, text: v.name });
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function(err) {

                }
            });
            $(_this.$refs.commodity_unit).select2({
                data: unitdata,
                width: '100%'
            });
        },
        // 选择商品库商品
        selectPlGoods() {
            let _this = this;

            _this.initPlGoods();
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'],
                title: ['选择商品', true],
                area: ['600px', ''],
                content: $(_this.$refs.pl_goods),
                offset: '100px'
            }, function() {
                $.map($(_this.$refs.pl_goods_list).bootstrapTable('getSelections'), function(row) {
                    // 商品名称
                    _this.cmdy_name = row.name;
                    // 商品单位
                    $(_this.$refs.commodity_unit).val(row.goods_unit).trigger('change');
                    // 商品类型
                    $(_this.$refs.commodity_detailtype).val(row.goods_type).trigger('change');
                    // 图片
                    _this.submitimg1 = row.img_url;
                    $('.defaultimage1').attr('suc', '1');
                    layer.closeAll();
                });
            });
        },
        // 初始化商品库商品
        initPlGoods: function() {
            let _this = this;

            $(_this.$refs.pl_goods_list).bootstrapTable('destroy');
            $(_this.$refs.pl_goods_list).bootstrapTable({
                pageNumber: 1,
                pageSize: 3,
                pageList: [],
                pagination: true,
                ajax: function(params) {
                    _this.getPlGoods(params);
                },
                sidePagination: "server",
                columns: [{
                    radio: true,
                    title: '单选',
                    valign: 'middle'
                }, {
                    field: "img_url",
                    title: "图片",
                    valign: 'middle',
                    formatter: function(value, row, index) {
                        return '<img class="imglogo" src="'+ value +'" />';
                    }
                }, {
                    field: "name",
                    title: "名称",
                    valign: 'middle'
                }, {
                    field: "goods_unit_name",
                    title: "单位",
                    valign: 'middle'
                }],
                clickToSelect: true
            });
        },
        getPlGoods: function(params) {
            let _this = this,
                pageNumber = 1;

            if(params.data.offset != 0) {
                pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit,
                        "name": _this.pl_goods_name
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "platformGoods/searchPlatformGoodsList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.data.total,
                            rows: data.response.result.data.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 查询商品库商品
        queryPlGoods() {
            this.initPlGoods();
        },
        // 添加商品单位
        addCmdyUnit: function() {
            let _this = this;
            layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['添加商品单位', true],
                area: ['550px', ''], //宽高
                content: $(_this.$refs.add_unit),
                offset: '100px'
            }, function() {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "name": _this.add_unit_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "merchantGoods/addGoodsUnit",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.closeAll();
                            layer.msg(data.response.error_msg);
                            _this.getGoodsUnit();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },
        // 点击上传图片
        addimageFun: function() {
            this.$refs.isflies1.click();
        },
        // 上传
        uploadimgFun: function(e) {
            var _this = this;
            var layIndex = layer.load(0, {
                shade: [0.1, '#ececec']
            });
            var file = e.target.files[0];
            // 清除file
            let obj = document.getElementById('isflies1');
            obj.value = '';
            obj.outerHTML = obj.outerHTML;
            // 压缩图片
            var reader = new FileReader(),
                img = new Image();
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            if(typeof(file) == 'undefined') {
                layer.msg('图片上传失败');
                layer.close(layIndex);
                return false;
            }
            reader.readAsDataURL(file);
            reader.onload = function(e) {
                img.src = e.target.result;
            };
            img.onload = function () {
                // 图片原始尺寸
                var originWidth = this.width;
                var originHeight = this.height;
                // 最大尺寸限制
                var maxWidth = 500, maxHeight = 500;
                // 目标尺寸
                var targetWidth = originWidth, targetHeight = originHeight;
                // 图片尺寸超过限制
                if(originWidth > maxWidth || originHeight > maxHeight) {
                    if(originWidth / originHeight > maxWidth / maxHeight) {
                        // 更宽，按照宽度限定尺寸
                        targetWidth = maxWidth;
                        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                    } else {
                        targetHeight = maxHeight;
                        targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                    }
                }
                // canvas对图片进行缩放
                canvas.width = targetWidth;
                canvas.height = targetHeight;
                // 清除画布
                context.clearRect(0, 0, targetWidth, targetHeight);
                // 图片压缩
                context.drawImage(img, 0, 0, targetWidth, targetHeight);
                // canvas转为blob并上传
                var dataurl = canvas.toDataURL('image/png');
                var blob = dataURLtoBlob(dataurl);
                // 创建forme
                var form = new FormData();
                form.append('img', blob, "image.png");
                form.append("upload_path", "ktv_test");
                // 上传
                $.ajax({
                    type: "post",
                    dataType: "json",
                    processData: false,
                    contentType: false,
                    url: Vue.ctUrl + "Upload/api_uploadPic",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: form,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.submitimg1 = data.response.resault.img_url;
                            $('.defaultimage1').attr('suc', '1');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg("图片上传失败");
                        }
                        layer.close(layIndex);
                    },
                    error: function(err) {
                        layer.msg("网络原因");
                        layer.close(layIndex);
                    }
                });
            }
        },
        // 上传成功
        successLoadImg: function(event) {
            if(event.target.complete == true) {
                // $('.defaultimage1').attr('suc', '1');
                var imgParentNode = event.target.parentNode;
                if(imgParentNode.classList.contains('show-img') == true) {
                    imgParentNode.style.background = "#000";
                }
            }
        },
        // 上传失败
        errorLoadImg: function() {
            $('.defaultimage1').removeAttr('suc');
        },
        onImgDel:function() {
            this.submitimg1 = require('../../assets/images/init1.png');
            this.$nextTick(() => {
                $('.defaultimage1').removeAttr('suc');
            })
        },
        // 资料同步全选
        synCheckedAll: function() {
            var _this = this;
            _this.syn_allcheck = _this.c_syn_allcheck;
            if(!_this.syn_allcheck) { // 实现全选
                _this.syn_checkboxModel = [];
                _this.syn_checkboxData.forEach(function(item) {
                    _this.syn_checkboxModel.push(item.id);
                });
            } else { // 实现反选
                _this.syn_checkboxModel = [];
            }
        },
        // 商品口味数据
        getTlistData: function() {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": '0',
                        "page_size": '0'
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/getGoodsFlavorList",
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        _this.tlist_checkboxData = data.response.result.rows;
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 商品口味全选
        tlistCheckedAll: function() {
            var _this = this;
            if(!this.tlist_allcheck) { // 实现全选
                _this.tlist_checkboxModel = [];
                _this.tlist_checkboxData.forEach(function(item) {
                    _this.tlist_checkboxModel.push(item.id);
                });
            } else { // 实现反选
                _this.tlist_checkboxModel = [];
            }
        },
        // 添加商品口味
        addCmdyTaste: function() {
            let _this = this;
            this.add_taste_name = '';
            let index = layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['添加商品口味', true],
                area: ['550px', ''], //宽高
                content: $(_this.$refs.add_taste),
                offset: '100px'
            }, function() {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "name": _this.add_taste_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "merchantGoods/addGoodsFlavor",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            _this.getTlistData();
                            layer.close(index);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },

        // 点击“新增口味类型”
        addNewFlavorType() {
            this.good_detail.flavors_info.push({
                flavor_type: "",
                data: [],
                flavors_str: '',
                flavors_id: []
            })
        },

        // 删除口味类型
        delFlavorType(index) {
            this.good_detail.flavors_info.splice(index, 1)
        },

        // 打开口味选择弹窗
        openFlavorPickPop(index) {
            let _this = this
            _this.tlist_checkboxModel = _this.good_detail.flavors_info[index].flavors_id || []
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: ['可选口味', true],
                area: ['550px', ''], // 宽高
                content: $(_this.$refs.flavor_pick_pop),
            }, function() {
                if (_this.tlist_checkboxModel.length < 1) {
                    layer.msg("请至少选择一种口味")
                    return
                }
                _this.good_detail.flavors_info[index].data = []
                _this.good_detail.flavors_info[index].flavors_str = ''
                _this.good_detail.flavors_info[index].flavors_id = []
                _this.tlist_checkboxModel.forEach(item => {
                    _this.tlist_checkboxData.forEach(k => {
                        if (k.id == item) {
                            _this.good_detail.flavors_info[index].data.push({
                                flavor_id: k.id,
                                flavor_name: k.name
                            })
                            _this.good_detail.flavors_info[index].flavors_id.push(k.id)
                            _this.good_detail.flavors_info[index].flavors_str += k.name + ','
                        }
                    })
                })
                _this.good_detail.flavors_info[index].flavors_str = _this.good_detail.flavors_info[index].flavors_str.substr(0,_this.good_detail.flavors_info[index].flavors_str.length - 1)
                layer.closeAll()
            });
        },

        formateFlavorInfo() {
            let res = []
            if (this.good_detail.flavors_info.length > 0) {
                let origin_flavors_info = JSON.parse(JSON.stringify(this.good_detail.flavors_info))
                origin_flavors_info.forEach(item => {
                    if (item.data.length > 0) {
                        let flavors_str = ''
                        item.flavors_id = [] 
                        item.data.forEach(k => {
                            flavors_str += k.flavor_name + ','
                            item.flavors_id.push(k.flavor_id)
                        })
                        flavors_str = flavors_str.substr(0, flavors_str.length - 1)
                        item.flavors_str = flavors_str
                    }
                    res.push(item)
                })
            }
            this.$set(this.good_detail, "flavors_info", res)
        },

        // 添加、修改商品
        goodSub: function(modify) {
            let _this = this;
            if(_this.cmdy_name == '') {
                layer.msg('请输入商品名称');
                return;
            }
            // 条形码
            _this.bar_codes = [];
            if(_this.modify_bar_code1 != '') {
                _this.bar_codes.push(_this.modify_bar_code1);
            }
            if(_this.modify_bar_code2 != '') {
                _this.bar_codes.push(_this.modify_bar_code2);
            }
            if(_this.modify_bar_code3 != '') {
                _this.bar_codes.push(_this.modify_bar_code3);
            }
            if(_this.modify_bar_code4 != '') {
                _this.bar_codes.push(_this.modify_bar_code4);
            }
            if(_this.modify_bar_code5 != '') {
                _this.bar_codes.push(_this.modify_bar_code5);
            }
            if(_this.modify_bar_code6 != '') {
                _this.bar_codes.push(_this.modify_bar_code6);
            }
            if(_this.modify_bar_code7 != '') {
                _this.bar_codes.push(_this.modify_bar_code7);
            }
            // 图片
            _this.imgs = [];
            if($('.defaultimage1').attr('suc') == '1') {
                _this.imgs.push(_this.submitimg1);
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "bar_codes": _this.bar_codes, // 条形码
                        "shop_id": $(_this.$refs.add_shop).val(), // 门店id
                        "platform_goods_name": _this.cmdy_name, // 商品名称
                        "goods_name": _this.cmdy_nickname, // 商品别名称
                        "goods_unit": $(_this.$refs.commodity_unit).val(), // 商品单位id
                        "goods_type": $(_this.$refs.commodity_detailtype).val(), // 商品类型id
                        "cost_price": _this.cmdy_price, // 原价
                        "discount_price": _this.cmdy_disctprice, // 折扣价
                        "vip_price": _this.cmdy_viprice, // 会员价
                        "vip_level1_price": _this.vip_level1_price,
                        "vip_level2_price": _this.vip_level2_price,
                        "vip_level3_price": _this.vip_level3_price,
                        "vip_level4_price": _this.vip_level4_price,
                        "vip_level5_price": _this.vip_level5_price,
                        "vip_level6_price": _this.vip_level6_price,
                        "vip_level7_price": _this.vip_level7_price,
                        "vip_level8_price": _this.vip_level8_price,
                        "vip_level9_price": _this.vip_level9_price,
                        "vip_level10_price": _this.vip_level10_price,
                        "listorder": _this.cmdy_sequence, // 显示顺序
                        "is_present": $(_this.$refs.commodity_giving).val(), // 是否赠送
                        "discount_status": $(_this.$refs.commodity_discount).val(), // 是否打折
                        "is_sell": $(_this.$refs.commodity_sale).val(), // 是否销售
                        "recommend": $(_this.$refs.commodity_recommended).val(), // 是否推荐
                        "is_minimum_consumption": $(_this.$refs.commodity_min).val(),
                        "available_stocking": $(_this.$refs.commodity_pd).val(),
                        "vip_present_pay": $(_this.$refs.commodity_hz).val(),
                        "customer_show": $(_this.$refs.commodity_cshow).val(),
                        "outstanding": $(_this.$refs.commodity_dt).val(),
                        "use_reward": $(_this.$refs.commodity_disc_use).val(),
                        "vip_points_pay": $(_this.$refs.commodity_hjd).val(),
                        "imgs": _this.imgs, // 图片
                        "des": _this.commodity_des,
                        "video_url": _this.video_url,
                        "shop_ids": _this.syn_checkboxModel, // 同步门店id
                        "flavors": _this.good_detail.flavors_info, // 口味id
                        "deduct_amount": _this.commodity_tc_numb,
                        "deduct_rate": _this.commodity_tc_perc,
                        "service_charge_rate": _this.commodity_serv_perc,
                        "forecast_cost_price": _this.commodity_forecast_cost,
                        "gross_margin_ratio": _this.commodity_gross_ratio,
                        "included_give_ratio": $(_this.$refs.commodity_kzb).val(),
                        "sales_commission": $(_this.$refs.commodity_sales_commission).val(),
                        "price_dynamics": $(_this.$refs.commodity_sjsp).val(),
                        "voucher_status": _this.voucher_status,
                        "voucher_type": _this.voucher_type,
                        "voucher_id": _this.voucher_id,
                        "is_ingredients": $(_this.$refs.commodity_ingredient).val(),
                        "ingredients": _this.ingredients_table,
                    }
                },
                "comment": ""
            };
            let url = Vue.ctUrl + "merchantGoods/addShopGoods";

            if(modify == '2') {
                datas["request"]["param"]["id"] = _this.good_detail.id;
                url = Vue.ctUrl + "merchantGoods/updateShopGoods";
                if (_this.syn_checkboxModel.length > 0 && !_this.syn_confirm_showed) {
                    layer.confirm('<span style="color: red;">当前资料修改将同步至其他门店，是否继续保存？若不需要同步，请重新勾选资料同步门店！</span>', {
                        btn: ['继续保存', '取消'],
                        title: '提示',
                    }, function () {
                        _this.syn_confirm_showed = true
                        _this.goodSub('2')
                    });
                    return
                }
            }
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: url,
                crossDomain: true,
                async: false,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        layer.msg(data.response.error_msg);
                        _this.detPage = false;
                        _this.listPage = true;

                        _this.send = '1';
                        // $(_this.$refs.commodity_manage_table).bootstrapTable("destroy");
                        // _this.innitable();
                        $(_this.$refs.commodity_manage_table).bootstrapTable("refresh");
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 获取商品详情
        getGoodDetail: function(id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/getShopGoodDetail",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    _this.good_detail = data.response.result;

                    // 条形码
                    _this.modify_bar_code1 = '';
                    _this.modify_bar_code2 = '';
                    _this.modify_bar_code3 = '';
                    _this.modify_bar_code4 = '';
                    _this.modify_bar_code5 = '';
                    _this.modify_bar_code6 = '';
                    _this.modify_bar_code7 = '';
                    $('.bar-code-2').addClass('bar-code-hide');
                    $('.bar-code-3').addClass('bar-code-hide');
                    $('.bar-code-4').addClass('bar-code-hide');
                    $('.bar-code-5').addClass('bar-code-hide');
                    $('.bar-code-6').addClass('bar-code-hide');
                    $('.bar-code-7').addClass('bar-code-hide');
                    $.each(_this.good_detail.bar_codes, function(k, v) {
                        if(k == '0') {
                            _this.modify_bar_code1 = v;
                        }
                        if(k == '1') {
                            _this.modify_bar_code2 = v;
                            $('.bar-code-2').removeClass('bar-code-hide');
                        }
                        if(k == '2') {
                            _this.modify_bar_code3 = v;
                            $('.bar-code-3').removeClass('bar-code-hide');
                        }
                        if(k == '3') {
                            _this.modify_bar_code4 = v;
                            $('.bar-code-4').removeClass('bar-code-hide');
                        }
                        if(k == '4') {
                            _this.modify_bar_code5 = v;
                            $('.bar-code-5').removeClass('bar-code-hide');
                        }
                        if(k == '5') {
                            _this.modify_bar_code6 = v;
                            $('.bar-code-6').removeClass('bar-code-hide');
                        }
                        if(k == '6') {
                            _this.modify_bar_code7 = v;
                            $('.bar-code-7').removeClass('bar-code-hide');
                        }
                    });

                    // 基本资料
                    $(_this.$refs.add_shop).select2({
                        data: _this.adShopArr,
                        minimumResultsForSearch: -1,
                        width: '100%'
                    });
                    $(_this.$refs.add_shop).val(_this.good_detail.shop_id).trigger('change');
                    $(_this.$refs.add_shop).prop('disabled', true);
                    _this.cmdy_name = _this.good_detail.platform_goods_name;
                    $(_this.$refs.cmdy_name).prop('disabled', true);
                    _this.cmdy_nickname = _this.good_detail.goods_name;
                    _this.getGoodsUnit();
                    $(_this.$refs.commodity_unit).val(_this.good_detail.goods_unit).trigger('change');
                    $(_this.$refs.commodity_detailtype).val(_this.good_detail.goods_type).trigger('change');
                    _this.cmdy_price = _this.good_detail.cost_price;
                    _this.cmdy_disctprice = _this.good_detail.discount_price;
                    _this.cmdy_viprice = _this.good_detail.vip_price;
                    _this.vip_level1_price = _this.good_detail.vip_level1_price;
                    _this.vip_level2_price = _this.good_detail.vip_level2_price;
                    _this.vip_level3_price = _this.good_detail.vip_level3_price;
                    _this.vip_level4_price = _this.good_detail.vip_level4_price;
                    _this.vip_level5_price = _this.good_detail.vip_level5_price;
                    _this.vip_level6_price = _this.good_detail.vip_level6_price;
                    _this.vip_level7_price = _this.good_detail.vip_level7_price;
                    _this.vip_level8_price = _this.good_detail.vip_level8_price;
                    _this.vip_level9_price = _this.good_detail.vip_level9_price;
                    _this.vip_level10_price = _this.good_detail.vip_level10_price;
                    _this.cmdy_sequence = _this.good_detail.listorder;

                    // 其他资料
                    $(_this.$refs.commodity_giving).val(_this.good_detail.is_present).trigger('change');
                    $(_this.$refs.commodity_discount).val(_this.good_detail.discount_status).trigger('change');
                    $(_this.$refs.commodity_sale).val(_this.good_detail.is_sell).trigger('change');
                    $(_this.$refs.commodity_recommended).val(_this.good_detail.recommend).trigger('change');
                    $(_this.$refs.commodity_min).val(_this.good_detail.is_minimum_consumption).trigger('change');
                    $(_this.$refs.commodity_pd).val(_this.good_detail.available_stocking).trigger('change');
                    $(_this.$refs.commodity_hz).val(_this.good_detail.vip_present_pay).trigger('change');
                    $(_this.$refs.commodity_cshow).val(_this.good_detail.customer_show).trigger('change');
                    $(_this.$refs.commodity_dt).val(_this.good_detail.outstanding).trigger('change');
                    _this.commodity_tc_numb = _this.good_detail.deduct_amount;
                    _this.commodity_tc_perc = _this.good_detail.deduct_rate;
                    _this.commodity_serv_perc = _this.good_detail.service_charge_rate;
                    _this.commodity_forecast_cost = _this.good_detail.forecast_cost_price;
                    _this.commodity_gross_ratio = _this.good_detail.gross_margin_ratio;
                    $(_this.$refs.commodity_disc_use).val(_this.good_detail.use_reward).trigger('change');
                    $(_this.$refs.commodity_hjd).val(_this.good_detail.vip_points_pay).trigger('change');
                    $(_this.$refs.commodity_kzb).val(_this.good_detail.included_give_ratio).trigger('change');
                    $(_this.$refs.commodity_sales_commission).val(_this.good_detail.sales_commission).trigger('change');
                    $(_this.$refs.commodity_sjsp).val(_this.good_detail.price_dynamics).trigger('change');
                    $(_this.$refs.commodity_ingredient).val(_this.good_detail.is_ingredients).trigger('change');
                    if (_this.good_detail.is_ingredients == '1') {                      
                        $('.list-img').hide();
                        $('.list-video').hide();
                        $('.list-syn').hide();
                        $('.list-taste').hide();
                        $('.list-coupon').hide();
                        $('.list-ingredients').hide()
                    }else {
                        $('.list-img').show();
                        $('.list-video').show();
                        $('.list-syn').show();
                        $('.list-taste').show();
                        $('.list-coupon').show();
                        $('.list-ingredients').show()
                    }

                    // 图片
                    _this.submitimg1 = require('../../assets/images/init1.png');
                    $('.defaultimage1').removeAttr('suc');
                    if(_this.good_detail.imgs.length > 0) {
                        _this.submitimg1 = _this.good_detail.imgs[0];
                        $('.defaultimage1').attr('suc', '1');
                    }
                    _this.commodity_des = _this.good_detail.des;

                        // 视频
                        _this.video_url = _this.good_detail.video_url;
                        _this.$nextTick(() => {
                            _this.videoUpload("video-wrapper")
                        })

                        // 资料同步
                        _this.syn_checkboxData = [];
                        if(_this.good_detail.shop_ids.length == '0' || _this.good_detail.is_ingredients == '1') {
                            $('.list-syn').hide();
                        } else {
                            $.each(_this.good_detail.shop_ids_info, function(k, v) {
                                _this.syn_checkboxData.push({ id: v.id, text: v.name });
                            });
                            $('.list-syn').show();
                        }
                        _this.syn_checkboxModel = _this.good_detail.shop_ids;

                    // 商品口味
                    _this.getTlistData();
                    // _this.tlist_checkboxModel = _this.good_detail.flavors;
                    _this.formateFlavorInfo()
                    // 关联券
                    _this.voucher_status = _this.good_detail.voucher_status
                    _this.voucher_type = _this.good_detail.voucher_type
                    _this.voucher_id = _this.good_detail.voucher_id
                    _this.voucher_name = _this.good_detail.voucher_name
                    // 配料商品
                    _this.ingredients_table = _this.good_detail.ingredients

                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 纠错原因
        reasonCon: function(txt) {
            this.feedback_reason = txt;
        },
        // 上传纠错图片
        addErrImg: function(num) {
            this.$refs.err_img.click(); 
        },
        // 上传纠错
        uploadErrImg: function(e) {
            var _this = this;
            var file = e.target.files[0];
            // 清除file
            let obj = document.getElementById('err_img');
            obj.value = '';
            obj.outerHTML = obj.outerHTML;
            // 压缩图片
            var reader = new FileReader(),
                img = new Image();
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            reader.readAsDataURL(file);
            reader.onload = function(e) {
                img.src = e.target.result;
            };
            img.onload = function () {
                // 图片原始尺寸
                var originWidth = this.width;
                var originHeight = this.height;
                // 最大尺寸限制
                var maxWidth = 230, maxHeight = 230;
                // 目标尺寸
                var targetWidth = originWidth, targetHeight = originHeight;
                // 图片尺寸超过限制
                if(originWidth > maxWidth || originHeight > maxHeight) {
                    if(originWidth / originHeight > maxWidth / maxHeight) {
                        // 更宽，按照宽度限定尺寸
                        targetWidth = maxWidth;
                        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                    } else {
                        targetHeight = maxHeight;
                        targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                    }
                }
                // canvas对图片进行缩放
                canvas.width = targetWidth;
                canvas.height = targetHeight;
                // 清除画布
                context.clearRect(0, 0, targetWidth, targetHeight);
                // 图片压缩
                context.drawImage(img, 0, 0, targetWidth, targetHeight);
                // canvas转为blob并上传
                var dataurl = canvas.toDataURL('image/png');
                var blob = dataURLtoBlob(dataurl);
                // 创建forme
                var form = new FormData();
                form.append('img', blob, "image.png");
                form.append("upload_path", "ktv_test");
                // 上传
                $.ajax({
                    type: "post",
                    dataType: "json",
                    processData: false,
                    contentType: false,
                    url: Vue.ctUrl + "Upload/api_uploadPic",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: form,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.err_url = data.response.resault.img_url;
                            $('.err-img').attr('suc', '1');
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg("图片上传失败");
                            $('.err-img').removeAttr('suc');
                        }
                    },
                    error: function(err) {
                        layer.msg("网络原因");
                        $('.err-img').removeAttr('suc');
                    }
                });
            }
        },
        // 禁用、启用、删除
        updatedata: function(status) {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "id": this.modify_id,
                        "status": status
                    }
                },
                "comment": ""
            };
            var layIndex = layer.load(0, {
                shade: [0.1, '#ececec']
            });
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/updateMerchantGoods",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function(data) {
                    if(data["response"]["result_code"] == "true") {
                        layer.msg(data["response"]["error_msg"]);
                        $(_this.$refs.commodity_manage_table).bootstrapTable('refresh');
                        _this.submitpage = false;
                        _this.modifypage = false;
                        _this.listPage = true;
                    } else {
                        layer.msg(data["response"]["error_msg"]);
                        Vue.timeoutfun(data.response.result_status, _this);
                    }
                    layer.close(layIndex);
                },
                error: function(err) {
                    layer.close(layIndex);
                }
            });
        },

        // 上传视频
        videoUpload: function(btnName) {
            if (this.uploaderList.length > 0) { // 销毁先前的实例
                this.uploaderList.forEach(v => {
                    v.destroy()
                })
            }
            
            let _this = this;
            let host = '',
                dir = '',
                file_name = '';

            setTimeout(function() {
                // 实例化一个plupload上传对象
                let uploader = new plupload.Uploader({
                    browse_button: btnName, // 选择文件id
                    filters: {
                        mime_types: [ // 文件格式限制
                            { title: "video files", extensions: "mp4" }
                        ],
                        max_file_size: '5mb', // 文件大小限制
                        prevent_duplicates: true // 不允许选取重复文件
                    },
                    // resize: {
                    //  width: 527,
                    //  height: 296
                    // },
                    multi_selection: false, // 单选
                    url: './', // OSS地址
                    init: {
                        // 文件上传前触发
                        BeforeUpload: function(up, file) {},
                        // 文件选择完毕触发
                        FilesAdded: function(up, files) {
                            // 获取签名
                            Vue.axios.post('publicData/api_getOssSignature', {
                                "header": Vue.request_header,
                                "request": {
                                    "version": Vue.version,
                                    "param": {
                                        "file": files[0].name,
                                        "path": 'Setting'
                                    }
                                },
                                "comment": ""
                            })
                            .then(res => {
                                if(res.data.response.result_code == "true") {
                                    host = res.data.response.data.host;
                                    dir = res.data.response.data.dir;
                                    file_name = res.data.response.data.file_name;
                                    const new_params = {
                                        'key': dir + file_name,
                                        'OSSAccessKeyId': res.data.response.data.accessid,
                                        'policy': res.data.response.data.policy,
                                        'signature': res.data.response.data.signature,
                                        'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
                                    };
                                    up.setOption({
                                        'url': host,
                                        'multipart_params': new_params
                                    });

                                    // 上传文件
                                    uploader.start();
                                } else {
                                    Vue.timeoutfun(data.response.result_status, _this);
                                    layer.msg(data.response.error_msg);
                                }
                            })
                            .catch(err => {
                                layer.msg("出错啦");
                            });
                        },
                        // 文件上传成功触发
                        FileUploaded: function(up, file, data) {
                            _this.video_url = host + "/" + dir + file_name;
                            layer.msg('上传成功');
                        },
                        // 错误提示
                        Error: function(up, err) {
                            if(err.code == -600) {
                                layer.msg('请选择5mb以内的文件');
                            } else if (err.code == -601) {
                                layer.msg('只允许上传mp4文件');
                            } else if (err.code == -602) {
                                layer.msg('这个文件已经上传过一遍了');
                            } else {
                                layer.msg(err.response);
                            }
                        }
                    }
                });
                // 初始化
                uploader.init();
                _this.uploaderList.push(uploader)
            }, 20);
        },

        onVideoDel: function () {
            this.video_url = ''
        },



        // 222222222222222222-------------------------
        // 初始化类型列表
        initTypesTable: function() {
            let _this = this;
            $(_this.$refs.typesList).bootstrapTable('destroy');
            $(_this.$refs.typesList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function(params) {
                    _this.getTypesList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "sort",
                    title: "显示顺序",
                    width: "25%"
                }, {
                    field: "name",
                    title: "商品类型",
                    width: "25%"
                }, {
                    field: "customer_show",
                    title: "消费者端显示",
                    width: "25%",
                    formatter: function(value, row, index) {
                        if(row.customer_show == '1') {
                            return '是';
                        } else if(row.customer_show == '-1') {
                            return '否';
                        }
                    }
                }, {
                    title: "操作",
                    width: "25%",
                    events: {
                        'click .edit': function(e, value, row) {
                            _this.typesSub(2, row);
                        },
                        'click .del': function(e, value, row) {
                            _this.deleteTypes(row.id);
                        }
                    },
                    formatter: function(value, row, index) {
                        let op_html = '';
                        $.each(_this.types_menu_op, function(k, v) {
                            op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
                        });
                        return op_html;
                    }
                }]
            });
        },
        // 类型数据
        getTypesList: function(params) {
            let _this = this,
                pageNumber = 1;
            if(params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/getGoodsTypeList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 添加、修改商品类型
        typesSub: function(num, row) {
            let _this = this;
            _this.types_sort = '';
            _this.types_name = '';
            $(_this.$refs.types_custm).val('').trigger('change');
            if(num == 2) {
                _this.types_sort = row.sort;
                _this.types_name = row.name;
                $(_this.$refs.types_custm).val(row.customer_show).trigger('change');
            }
            layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['商品类型', true],
                area: ['600px', ''], //宽高
                content: $(_this.$refs.types_edit),
                offset: '100px'
            }, function() {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "sort": _this.types_sort,
                            "name": _this.types_name,
                            "customer_show": $(_this.$refs.types_custm).val()
                        }
                    },
                    "comment": ""
                };
                let url = '';
                if(num == 1) {
                    url = Vue.ctUrl + "merchantGoods/addGoodsType";
                } else if(num == 2) {
                    datas["request"]["param"]["id"] = row.id;
                    url = Vue.ctUrl + "merchantGoods/updateGoodsType";
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: url,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.typesList).bootstrapTable('refresh');
                            layer.closeAll();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },
        // 删除类型
        deleteTypes: function(id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/delGoodsType",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas2,
                success: function(data) {
                    if(data.response.result_code == "true") {
                        if(data.response.result_status == '99') {
                            layer.msg(data.response.error_msg);
                        } else {
                            $(_this.$refs.typesList).bootstrapTable('refresh');
                            layer.msg('删除成功');
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },



        // 333333333333333333333-------------------------
        // 初始化口味列表
        initTasteTable: function() {
            let _this = this;
            $(_this.$refs.tasteList).bootstrapTable('destroy');
            $(_this.$refs.tasteList).bootstrapTable({
                pageNumber: 1,
                pageSize: 10,
                pageList: [],
                pagination: true,
                ajax: function(params) {
                    _this.getTasteList(params);
                },
                sidePagination: "server",
                columns: [{
                    field: "index",
                    title: "序号",
                    width: "33%",
                    formatter: function(value, row, index) {
                        return index + 1;
                    }
                }, {
                    field: "name",
                    title: "商品口味",
                    width: "33%"
                }, {
                    title: "操作",
                    width: "33%",
                    events: {
                        'click .edit': function(e, value, row) {
                            _this.tasteSub(2, row);
                        },
                        'click .del': function(e, value, row) {
                            _this.deleteTaste(row.id);
                        }
                    },
                    formatter: function(value, row, index) {
                        let op_html = '';
                        $.each(_this.taste_menu_op, function(k, v) {
                            op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
                        });
                        return op_html;
                    }
                }]
            });
        },
        // 口味列表数据
        getTasteList: function(params) {
            let _this = this,
                pageNumber = 1;
            if(params != "" && params.data.offset != 0) {
                pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
            }
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": pageNumber,
                        "page_size": params.data.limit
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/getGoodsFlavorList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        params.success({
                            total: data.response.result.total,
                            rows: data.response.result.rows
                        });
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                        params.success({
                            total: 0,
                            rows: 0
                        });
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },
        // 添加口味
        tasteSub: function(num, row) {
            let _this = this;
            _this.taste_name = '';
            if(num == 2) {
                _this.taste_name = row.name;
            }
            layer.confirm('', {
                skin: 'add_goods-alert',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['商品口味', true],
                area: ['600px', ''], //宽高
                content: $(this.$refs.taste_edit),
                offset: '100px'
            }, function() {
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "name": _this.taste_name
                        }
                    },
                    "comment": ""
                };
                let url = '';
                if(num == 1) {
                    url = Vue.ctUrl + "merchantGoods/addGoodsFlavor";
                } else if(num == 2) {
                    datas["request"]["param"]["id"] = row.id;
                    url = Vue.ctUrl + "merchantGoods/updateGoodsFlavor";
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: url,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.tasteList).bootstrapTable('refresh');
                            layer.closeAll();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            });
        },
        // 删除口味
        deleteTaste: function(id) {
            let _this = this;
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "id": id
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/delGoodsFlavor",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas2,
                success: function(data) {
                    if(data.response.result_code == "true") {
                        if(data.response.result_status == '99') {
                            layer.msg(data.response.error_msg);
                        } else {
                            $(_this.$refs.tasteList).bootstrapTable('refresh');
                            layer.msg('删除成功');
                        }
                    } else {
                        Vue.timeoutfun(data.response.result_status, _this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 打开“关联券弹窗”
        openVoucherPop() {
            let _this = this
            if (this.voucher_status == '-1') {
                return
            }
            this.voucher_type = (this.modify == 2 && this.good_detail.voucher_type != '') ? this.good_detail.voucher_type : '1'// 1：巨嗨卡券，2：友宝售后机商品券
            this.card_type_name = '' // 卡券名称
            this.query_voucher_name = '' // 关联券弹窗检索名称
            let c_voucher_type = (this.modify == 2 && this.good_detail.voucher_type != '') ? this.good_detail.voucher_type : '1'
            
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['保存', '取消'],
                title: ['请选择商品关联券', true],
                area: ['780px', '580px'],
                content: $(_this.$refs.coupon_pop),
                offset: '100px',
                cancel: function() {
                    // 右上角关闭
                    _this.voucher_type = c_voucher_type
                }
            }, function() {
                if (!_this.choosedVoucher.goods_name) {
                    layer.msg("请先选择关联券")
                    return
                }
                _this.voucher_id = _this.choosedVoucher.goods_id
                _this.voucher_name = _this.choosedVoucher.goods_name + '（' + _this.choosedVoucher.goods_type_name +'）'
                layer.closeAll()
            }, function() {
                _this.voucher_type = c_voucher_type
            });

            _this.$nextTick(() => {
                _this.getPopCouponList(1)
            })
        },

        // 获取卡券列表
        getCouponList: function(page) {
            let _this = this
            _this.pop_loading = true
            _this.coupon_page = page
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.coupon_page_size,
                        "shop_id": $(_this.$refs.add_shop).val(),
                        "type": $.trim(_this.card_type_name),
                        "name": _this.query_voucher_name
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "MerchantGift/getList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        if(page == 1) {
                            _this.coupon_total = Number(data.response.result.count);
                        }
                        _this.coupon_list = data.response.result.data;
                        _this.pop_loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 获取售后机商品券列表
        getUboxVoucherList: function(page) {
            let _this = this
            _this.pop_loading = true
            _this.coupon_page = page
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.coupon_page_size,
                        "shop_id": $(_this.$refs.add_shop).val(),
                        "type": $.trim(_this.card_type_name),
                        "name": _this.query_voucher_name
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "MerchantGift/getUboxVoucherList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        if(page == 1) {
                            _this.coupon_total = Number(data.response.result.count);
                        }
                        _this.coupon_list = data.response.result.data;
                        _this.pop_loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 关联券弹窗券类型变化
        onVoucherTypeChange(val) {
            this.card_type_name = ''
            if (val == '1') {
                this.getCouponList(1)
            }else {
                this.getUboxVoucherList(1)
            }
        },

        // 获取弹窗列表
        getPopCouponList(page) {
            if (this.voucher_type == '1') {
                this.getCouponList(page)
            }else {
                this.getUboxVoucherList(page)
            }
        },

        // 点击兑换弹窗“查询”
        onPopQueryClick() {
            this.choosedVoucher = {}
            this.getPopCouponList(1)
        },

        // 选择券
        onPopCouponSelect (val, row) {
            this.$refs.coupon_table.clearSelection()
            this.$refs.coupon_table.toggleRowSelection(row, true)
            this.choosedVoucher = row
        },


        // 打开配料“添加商品”
        openAddIngredientsPop() {
            let _this = this
            _this.choosedIngredients = []
            _this.ingredients_pop_form = {
                goods_type: '',
                goods_name: '',
            }
            
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['保存', '取消'],
                title: ['添加商品', true],
                area: ['780px', '530px'],
                content: $(_this.$refs.add_ingredients_pop),
                offset: '100px',
            }, function() {
                if (_this.choosedIngredients.length > 0) {
                    var arr = _this.ingredients_table
                    $.each(_this.choosedIngredients, function(k, v) {
                        for(var i = 0; i < arr.length; i++) {
                            if(arr[i].id == v.id) {
                                layer.msg("商品已存在");
                                return;
                            }
                        }
                        arr.push({
                            id: v.id,
                            ingredients_goods_id: v.id,
                            goods_name: v.goods_name,
                            goods_type_name: v.goods_type_name,
                            goods_unit_name: v.goods_unit_name,
                            quantity: ''
                        })
                    });
                    _this.ingredients_table = arr
                    layer.msg('添加成功');
                }else {
                    layer.msg("请先选择商品")
                }
            });

            _this.$nextTick(() => {
                _this.getIngredientsList(1)
            })
        },

        // 获取配料商品列表
        getIngredientsList: function(page) {
            let _this = this
            _this.pop_loading = true
            _this.ingredients_pop_page = page
            let datas = {
                "header": Vue.request_header,
                "request": {
                    "version": Vue.version,
                    "param": {
                        "page": page,
                        "page_size": _this.coupon_page_size,
                        "shop_id": $(_this.$refs.add_shop).val(),
                        "goods_type": _this.ingredients_pop_form.goods_type,
                        "goods_name": _this.ingredients_pop_form.goods_name,
                        "is_ingredients": 1
                    }
                },
                "comment": ""
            };
            let datas2 = JSON.stringify(datas);
            $.ajax({
                type: "post",
                dataType: "json",
                url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    json: datas2
                },
                success: function(data) {
                    if(data.response.result_code == "true") {
                        if(page == 1) {
                            _this.ingredients_pop_total = Number(data.response.result.data.total);
                        }
                        _this.ingredients_pop_table = data.response.result.data.rows;
                        _this.pop_loading = false;
                    } else {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data.response.error_msg);
                    }
                },
                error: function(err) {
                    layer.msg("出错啦");
                }
            });
        },

        // 配料商品弹窗选择
        handleIngredientsPopSelectionChange(val) {
            this.choosedIngredients = val
        },

        updateIngredientsQuantity(row) {
            this.$forceUpdate()
        },

        // 删除商品
        delIngredients(index) {
            this.ingredients_table.splice(index, 1)
        },

    }
}
</script>
<style lang="less">
    .commodity-list {
        .page-flow {
            color: #757575;
            font-size: 14px;
            span {
                color: #45ACF4;
            }
        }
        .add-code {
            padding: 20px 0 20px 20px;
            background: #f5f5f5;
            h4 {
                margin: 0 0 20px;
            }
            img {
                width: 29px;
                cursor: pointer;
            }
            .col-md-6 {
                margin: 0 0 20px;
            }
            .bar-code-hide {
                display: none;
            }
        }
        .list_content {
            .pull-right {
                button {
                    margin: 0 0 0 30px;
                }
            }
            table {
                table-layout: fixed;
                word-wrap: break-word;
            }
            .rowmagin {
                a {
                    margin: 0 30px;
                    line-height: 26px;
                }
                input[type=file] {
                    display: none;
                }
            }
        }
        .list-det {
            .btn-hide {
                display: none;
            }
            .rowpadding {
                padding: 0;
                margin-bottom: 36px;
            }
            .cmdy-vip-hint {
                float: left;
                height: 30px;
                margin: 0 0 0 15px;
                line-height: 30px;
                color: #F00;
                font-size: 14px;
            }
        }
        .list-base {
            display: none;
            padding: 20px 0 20px 20px;
            margin: 20px 0;
            background: #f5f5f5;
            h4 {
                margin: 0 0 20px;
            }
            h5 {
                margin: 0px 0px 41px;
                line-height: 32px;
            }
        }
        .list-other {
            display: none;
            padding: 20px 0 20px 20px;
            background: #f5f5f5;
            h4 {
                margin: 0 0 20px;
            }
            .col-md-3 {
                width: 120px;
            }
            .ctr-hint-txt {
                margin: 0 5px 0 0;
            }
        }
        .list-img {
            display: none;
            padding: 20px 0 20px 20px;
            margin: 20px 0;
            background: #f5f5f5;
            h4 {
                margin: 0 0 20px;
                span {
                    font-size: 14px;
                }
            }
            .uploadinput {
                display: none;
            }
            .uploadimg {
                width: 158px;
                height: 158px;
                border: none;
                position: relative;
                margin-left: 15px;
            }
            .defaultimage1 {
                width: 158px;
                height: 158px;
                cursor: pointer;
                border: none;
            }
            .defaultimage2 {
                width: 158px;
                height: 158px;
                background: url('../../assets/images/init2.png') no-repeat;
                background-size: 100%;
                cursor: pointer;
            }
            .defaultimage3 {
                width: 158px;
                height: 158px;
                background: url('../../assets/images/init3.png') no-repeat;
                background-size: 100%;
                cursor: pointer;
            }
            .defaultimage4 {
                width: 158px;
                height: 158px;
                background: url('../../assets/images/init4.png') no-repeat;
                background-size: 100%;
                cursor: pointer;
            }
            div {
                margin: 0 0 20px;
            }
            p {
                clear: both;
                padding: 0 0 0 15px;
            }
            textarea {
                resize: none;
                outline: none;
                width: 100%;
                height: 100px;
                padding: 8px 15px;
                border: 1px solid #ccc;
                font-size: 14px;
            }
            .del-icon {
                margin-top: -150px;
                margin-left: -10px;
            }
            .btns {
                height: 158px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                .el-button {
                    margin: 15px 0 0 0;
                }
            }
        }
        .list-video {
            display: none;
            padding: 20px 0 20px 20px;
            margin: 20px 0;
            background: #f5f5f5;
            h4 {
                margin: 0 0 20px;
                span {
                    font-size: 14px;
                }
            }
            h5 {
                font-size: 14px;
                .red-txt {
                    color: red;
                    padding-left: 10px;
                } 
            }
            .video-wrapper {
                position: relative;
                width: 158px;
                height: 158px;
                margin: 10px 0;
                cursor: pointer;
                img,
                video {
                    width: 100%;
                    height: 100%;
                }
                .del-icon {
                    position: absolute;
                    top: -15px;
                    right: -25px;
                    width: 33px;
                    height: 33px;
                }
            }
        }
        .list-syn {
            display: none;
            padding: 20px 0 20px 20px;
            background: #f5f5f5;
            h4 {
                margin: 0 0 30px;
                span {
                    font-size: 12px;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .list-taste {
            display: none;
            padding: 20px 0 20px 20px;
            margin: 20px 0 0;
            background: #f5f5f5;
            h4 {
                margin: 0 0 30px;
                span {
                    font-size: 12px;
                }
            }
            .list-taste-sel {
                margin: 0 0 20px;
                ul {
                    min-height: 30px;
                }
                li {
                    float: left;
                    text-indent: 2em;
                    height: 30px;
                    line-height: 30px;
                }
            }
            .list-taste-list {
                h5 {
                    margin: 0 0 20px;
                    span {
                        display: inline-block;
                        width: 60px;
                        height: 24px;
                        border: 1px solid #CCC;
                        margin: 0 0 0 20px;
                        line-height: 22px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
                li {
                    float: left;
                    width: 20%;
                    margin: 0 0 30px;
                    font-size: 14px;
                    input {
                        float: left;
                        margin: 2px 10px 0 30px;
                    }
                    label {
                        margin: 0;
                        font-weight: normal;
                    }
                }
            }
            .flavor-row {
                margin-bottom: 20px;
                display: flex;
                flex-direction: row;
                align-items: center;
                .row-label {
                    margin-right: 10px;
                    margin-left: 20px;
                    color: #5e5e5e;
                }
                .el-input {
                    width: 400px;
                    margin-right: 10px;
                    &.short {
                        width: 300px;
                    }
                }
            }
        }
        .list-qrcode {
            ul {
                margin: 0 0 36px;
                color: #F00;
            }
            .list-shop-cg {
                padding: 0 12px;
                line-height: 32px;
                font-size: 14px;
                background: #EEE;
                border: 1px solid #AAA;
            }
            .list-img-wrap {
                border: 1px solid #AAA;
                padding: 20px 0;
                margin: 0 15px;
                img {
                    display: block;
                    width: 337px;
                    margin: 0 auto;
                }
            }
        }
        .list-coupon {
            padding: 20px 0 20px 20px;
            margin: 20px 0 0;
            background: #f5f5f5;
            h4 {
                margin: 0 0 30px;
            }
            .coupon-row {
                display: flex;
                flex-direction: row;
                align-items: center;
                .el-input {
                    width: 400px;
                    margin-left: 20px;
                }
            }
        }
        .querytxt {
            padding-left: 0;
            margin: 2px 0 0 -36px;
        }
        .set-export {
            padding: 0 20px 20px;
            h3 {
                font-size: 16px;
            }
            li {
                float: left;
                width: 20%;
            }
        }
        .flavor-pick-pop {
            .pop-title {
                margin-bottom: 20px;
                .el-button {
                    margin-left: 10px;
                }
            }
            .el-checkbox {
                min-width: 130px;
                margin-bottom: 10px;
            }
        }
    }
    .goods-multi-edit {
        display: none;
        .row {
            clear: both;
            margin: 0 0 20px;
        }
        .el-checkbox {
            float: left;
            margin-top: 10px;
        }
        .el-form-item__label {
            width: 124px;
            text-align: left;
        }
        .beyond {
            line-height: 20px;
        }
        .el-input {
            width: 300px;
        }
        .el-input__inner {
            height: 40px!important;
        }
    }
    .add-good {
        display: none;
        .bs-checkbox {
            input {
                margin: 15px 0 0 !important;
            }
        }
    }
    .big-img {
        display: none;
        img {
            display: block;
            width: 230px;
            height: 230px;
            margin: 30px auto 50px;
        }
    }
    .big-img-skin {
        .layui-layer-btn {
            display: none;
        }
    }
    .feedback {
        display: none;
        font-size: 14px;
        p {
            font-size: 16px;
        }
        span {
            color: #8b8b8b;
        }
        .feedback-txt {
            padding: 10px 8px;
            border: 1px solid #C1C1C1;
            margin: 20px 0 0;
            border-radius: 5px;
            textarea {
                resize: none;
                outline: none;
                width: 100%;
                height: 100px;
                border: none;
            }
            ul {
                width: 86%;
                padding: 15px 0 0;
                margin: 0 auto;
                border-top: 1px solid #DBDBDB;
                li {
                    float: left;
                    width: 100px;
                    height: 30px;
                    border: 1px solid #86C9FF;
                    margin: 0 20px 0 0;
                    line-height: 30px;
                    color: #86C9FF;
                    text-align: center;
                    cursor: pointer;
                    border-radius: 3px;
                }
            }
        }
        .feedback-img {
            h5 {
                margin: 30px 0;
                color: #8b8b8b;
            }
            img {
                width: 191px;
                height: 193px;
                background: url('../../assets/images/uld_btn.png') no-repeat;
                background-size: 100%;
                cursor: pointer;
            }
            input {
                display: none;
            }
        }
    }
    .add-unit, .add-taste {
        display: none;
        width: 70%;
        margin: 0 auto;
    }

    .choose-cloud-good {
        .red-tip {
            color: red;
            margin-bottom: 20px;
        }
        .el-input {
            width: 240px;
        }
        .goods-wrapper {
            max-height: 380px;
            min-height: 200px;
            margin-top: -30px;
            margin-bottom: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
            .item {
                position: relative;
                height: 130px;
                width: 130px;
                border: 2px solid #AAA;
                margin: 20px 10px;
                .img {
                    width: 100%;
                    height: 100%;
                }
                .name {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    line-height: 30px;
                    font-size: 14px;
                    color: #fff;  
                    background-color: rgba(0,0,0,.5);  
                }
                .choose {
                    position: absolute;
                    top: -10px;
                    right: -10px;   
                    width: 25px;
                    height: 25px;
                    border-radius: 50%;
                    border: 2px solid #aaa;
                    background-color: #fff;
                    &.active {
                        background-color: #009af0;
                    }
                }
            }
        }
        .el-pagination {
            .el-input {
                width: 60px;
            }
        }
    }

    .commodity-types {
        .types-list {
            p {
                line-height: 50px;
                color: #F00;
                margin: 0;
            }
        }
        .types-edit {
            display: none;
            width: 70%;
            margin: 0 auto;
        }
    }

    .taste-edit {
        display: none;
        width: 70%;
        margin: 0 auto;
    }

    .checkboxdiv {
        max-height: 126px;
        overflow: auto;
    }

    .shopul li {
        position: relative;
        display: block;
        width: 50%;
        float: left;
    }
    #submitbtn {
        margin-left: 40px;
    }
    .queryrow {
        padding-left: 0;
        margin-left: -16px;
    }
    .rowmagin {
        margin-bottom: 50px;
    }
    #employee_name {
        border-left: none;
    }
    .add_goods-alert .layui-layer-wrap {
        padding: 40px;
    }


    .pl-goods {
        display: none;
        padding: 20px 30px 50px;
        .table-responsive {
            margin: 30px 0 0;
        }
    }

    // 关联券弹窗
    .coupon-pop {
        .el-form {
            .el-input,
            .el-select {
                width: 200px;
                margin-right: 10px;
            }
        }
        .el-table__header-wrapper > table > thead .el-checkbox {
            display: none!important;
        }
        .el-table {
            margin-top: 30px;
        }
    }

    .list-ingredients {
        padding: 20px 0 20px 20px;
        margin: 20px 0 0;
        background: #f5f5f5;
        h4 {
            margin: 0 0 30px;
            .red-tip {
                padding-left: 10px;
                font-size: 12px;
                color: red;
            }
        }
        .el-table {
            width: 900px;
        }
    }
    .ingredients-pop {
        .el-form {
            .el-input,
            .el-select {
                width: 300px;
                margin-right: 10px;
            }
        }
    }
</style>